(function() {
  'use strict';

  angular
    .module('profsystem', ['ngCookies', 'ngSanitize', 'ui.router', 'toastr', 'ngMaterial', 'ngMdIcons', 'md.data.table', 'ngFileUpload','ngSessionStorage', 'ckeditor']);

})();


(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('timeModelController', timeModelController);

  /** @ngInject */
  function timeModelController($scope, $stateParams, $mdBottomSheet, $mdDialog, $http, $log, $document) {

      var vm = this;

      /* 요일 */

      vm.day_str={
          "mon" : "월요일",
          "tue" : "화요일",
          "wed" : "수요일",
          "thu" : "목요일",
          "fri" : "금요일",
          "sat" : "토요일"
      }

      vm.day_list = [{
          text : '월',
          day: 'mon'
      }, {
          text : '화',
          day: 'tue'
      }, {
          text : '수',
          day: 'wed'
      }, {
          text : '목',
          day: 'thu'
      }, {
          text : '금',
          day: 'fri'
      }, {
        text : '토',
        day: 'sat'
      }];

      //학부/대학원
      vm.graduate_list = [{
          text : '학부',
          graduate: 1
      }, {
          text : '대학원',
          graduate: 2
      }];

       /* --- 요일 --- */
       /* Alert Dialog */

      vm.showAlert = function(title,msg) {
          $mdDialog.show(
              $mdDialog.alert()
                  //.parent(agular.element(document.querySelector('#popupContainer')))n
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(msg)
                  .ariaLabel('Alert Dialog')
                  .ok("확인")
          );
      };

       /* --- Alert Dialog --- */

      /* Timemodel 불러오기 */


      vm.init_timemodel = function(){
          $http.get('/timemodel').then(successCallback_timemodel, errorCallback_timemodel);

          function successCallback_timemodel(response) {
              vm.list_timemodel = response.data;
          }
          function errorCallback_timemodel(error) {
              $log.log(error, 'can not get data.');
          }
      }

      vm.init_timemodel();

      /* --- Timemodel 불러오기 --- */

       /* 모형 삭제 다이얼로그 */

      vm.show_delete_model = function(model_info) {
          var confirm = $mdDialog.confirm()
              .title('수업 모형 삭제')
              .textContent(model_info.lecture_code + ' 수업 모형을 영구적으로 삭제합니다.')
              .ok('삭제')
              .cancel('취소');
          $mdDialog.show(confirm).then(function() {
              vm.delete_model(model_info.id,model_info.lecture_code);
          }, function() {
              vm.status = '놔둠';
          });
      };

      vm.delete_model = function(model_id,lecture_code) {
          $http.post(('/timemodel/deleteModel'), {
              id : model_id
          }).then(function (result) {
              if(result.data.result) {
                  vm.showAlert("삭제 완료",lecture_code + "모형이 삭제되었습니다.");
                  vm.init_timemodel();
              }else{
                  vm.showAlert("삭제 실패",lecture_code + "모형 삭제에 실패하였습니다.");
                  //vm.init_subject();
              }
          });
      };

       /* --- 모형 삭제 다이얼로그 --- */

      /* 시간 삭제 다이얼로그 */

      vm.show_delete_time = function(time_info){
          var confirm = $mdDialog.confirm()
              .title('시간 삭제')
              .textContent(vm.day_str[time_info.day] + ' 시간을 수업 모형에서 삭제합니다.')
              .ok('삭제')
              .cancel('취소');
          $mdDialog.show(confirm).then(function() {
              vm.delete_time(time_info.id,vm.day_str[time_info.day]);
          }, function() {
              vm.status = '놔둠';
          });
      };

      vm.delete_time = function(timeid,time_name) {
          $http.post(('/timemodel/deleteTime'), {
              timeid:timeid
          }).then(function (result) {
              if(result.data.result) {
                  vm.showAlert("삭제 완료",time_name + "에 해당하는 시간이 삭제되었습니다.");
                  vm.init_timemodel();
              }else{
                  vm.showAlert("삭제 실패",time_name + "에 해당하는 시간 삭제에 실패하였습니다.");
                  //vm.init_subject();
              }
          });
      };

      /* --- 시간 삭제 다이얼로그 --- */

      /* 시간 추가 */

      vm.add_time = function(id,day,start,finish){
          $http.post(('/timemodel/insertTime'), {
              id : id,
              day : day,
              start_time : start,
              finish_time : finish
          }).then(function (result) {
              if(result.data.result) {
                  vm.showAlert("추가 완료", "시간이 추가되었습니다.");
                  //alert("추가되었습니다.\nresult : " + result.data.result + "\nday : " + day);
                  //$log.log("추가 : " + code + "," + day + "," + start + "," + end);
                  vm.init_timemodel();
              }else{
                  vm.showAlert("추가 실패", "시간 추가에 실패하였습니다.");
                  //vm.init_subject();
              }
          });
      }

      /* --- 시간 추가 --- */

      /* 시간 수정*/

      vm.modify_time = function(timeid,day,start,finish){
          $log.log("수정 : "  + timeid + "," + day + "," + start+ "," + finish);
          $http.post(('/timemodel/modifyTime'), {
              timeid : timeid,
              day : day,
              start_time : start,
              finish_time : finish
          }).then(function (result) {
              if(result.data.result) {
                  vm.showAlert("수정 완료", vm.day_str[day] + "에 해당하는 시간이 수정되었습니다.");
                  vm.init_timemodel();
              }else{
                  vm.showAlert("수정 실패", vm.day_str[day] + "에 해당하는 시간 수정에 실패하였습니다.");
                  //vm.init_subject();
              }
          });
      }

      /* --- 시간 수정 --- */

      /* 모형 수정*/

      vm.modify_model = function(id,code,timeunit,graduate){
          $http.post(('/timemodel/modifyModel'), {
              id : id,
              code : code,
              timeunit : timeunit,
              graduate : graduate
          }).then(function (result) {
              if(result.data.result) {
                  vm.showAlert("수정 완료", code + "모형으로 수정되었습니다.");
                  vm.init_timemodel();
              }else{
                  vm.showAlert("수정 실패", "모형 수정에 실패하였습니다.");
                  //vm.init_subject();
              }
          });
      }

      /* --- 모형 수정 --- */

      /* 모형 추가 Dialog */

      vm.show_add_model = function() {
          $mdDialog.show({
              controller: AddModelDialogController,
              templateUrl: 'app/timemodel/dialog_add.html',
              parent: angular.element($document.body),
              clickOutsideToClose:true
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
          })
              .then(function(answer) {
                  vm.status = 'You said the information was "' + answer + '".';
                  //$log.log("answer : " + answer);
              }, function() {
                  vm.status = 'You cancelled the dialog.';
              });
      };

      /* --- 모형 추가 Dialog --- */

      /* 모형 추가 Controller */

      function AddModelDialogController($scope, $mdDialog) {

          var dialogcon = $scope;

          dialogcon.day_list = vm.day_list;
          dialogcon.graduate_list = vm.graduate_list;

          /* Error */

          dialogcon.str_error = null;
          dialogcon.list_str_error = {
              "code" : "수업 모형의 이름을 입력해주세요.",
              "timeunit" : "시수를 입력해주세요.",
              "graduate" : "학부/대학원 여부를 입력해주세요.",
              "code_same" : "이미 존재하는 이름입니다.",
              "fail_insert" :  "추가에 실패하였습니다.\n입력 항목이 올바른지 확인해주세요."
          }

          dialogcon.showError = function(type){
              dialogcon.str_error = dialogcon.list_str_error[type];
              return true;
          }

          /* --- Error --- */


          dialogcon.showAlert = function(title,msg){
              vm.showAlert(title,msg);
          }

          dialogcon.hide = function() {
              $mdDialog.hide();
          };

          //모형 추가
          dialogcon.add_model = function(code,timeunit,graduate) {

              //$log.log("추가 : " + code + "," + timeunit + "," + graduate);

              /* 검사 */

              if ((!code && dialogcon.showError("code"))
                  || (!timeunit && dialogcon.showError("timeunit"))
                  || (!graduate && dialogcon.showError("graduate")))
                  return;

              for(var index in vm.list_timemodel){
                  if(vm.list_timemodel[index].lecture_code == code){
                      dialogcon.showError("code_same");
                      return;
                  }
              }

              /* --- 검사 --- */

              $http.post(('/timemodel/insertModel'), {
                  code : code,
                  timeunit : timeunit,
                  graduate : graduate
              }).then(function (result) {
                  if(result.data.result) {
                      vm.showAlert("추가 완료",code + "모형이 추가되었습니다.");
                      vm.init_timemodel();
                      $mdDialog.hide();
                  }else dialogcon.showError("fail_insert");
              });

          };

      }

      /* --- 모형 추가 Controller --- */

  }
})();

/**
 * Created by user on 2017-07-31.
 */
(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('SystemController', SystemController);

  function SystemController($scope, $http, $log){
    var vm = this;
    vm.log = $log.log;

    $http.get('/year').then(function(res){

      vm.year = res.data.year;
      vm.log(res.data);
    });

    vm.setYear = function setYear(year){
      $http.post('/year', {
        year: year
      }).then(function(res){
        if(res.data.result) alert('연도가 성공적으로 수정되었습니다.');
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('RequestController', RequestController);

    /** @ngInject */
    function RequestController($scope, $state, $stateParams, $mdDialog, $http, $log, $document, stype_str, lecture_type_str, foreign_select_str, isflipped_str) {
      var vm = this;

      vm.wantedValue = "/classes/requestlistexcel";

      vm.stype_str = stype_str;
      vm.lecture_type_str = lecture_type_str;
      vm.foreign_select_str = foreign_select_str;
      vm.isflipped_str = isflipped_str;
      vm.request_info = [];    
      vm.$log = $log;

      vm.query = {
          order: 'semester',
          limit: 7,
          page: 1
      };

      vm.dept_key_str = {
        'CSE': "컴퓨터공학과",
        'ECE': "전자전기컴퓨터공학과",
        'EEE': "전자전기공학부",
        'SSE': "반도체시스템공학과",
        'SWE': "소프트웨어학과",
        'CSC': "전자전기+반도체시스템공학",
        'ESC': "컴퓨터공학+반도체시스템공학",
        'DMC': "DMC공학과",
        'ENS': "에너지시스템공학협동과정",
        'ESW': "임베디드소프트웨어학과",
        'MCE': "이동통신전력전자공학과",
        'MSE': "IT융합학과",
        'PSE': "태양광시스템공학협동과정",
        'SDE': "반도체디스플레이공학과"
      }

      $mdDialog.hide();

      /* Alert Dialog */

      vm.showAlert = function(title,msg) {
          $mdDialog.show(
              $mdDialog.alert()
                  //.parent(agular.element(document.querySelector('#popupContainer')))n
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(msg)
                  .ariaLabel('Alert Dialog')
                  .ok("확인")
          );
      };

      /* --- Alert Dialog --- */

      // 신청교수 데이터테이블
      vm.init_req = function() {
        $http.get('/classes/requestlist').then(successCallback, errorCallback);

        function successCallback(response) {
          vm.request_info = response.data;
            if (response.data[0] == null) {
              vm.message = "신청한 교수님이 없습니다.";
            }
        }

        function errorCallback(error) {
          vm.$log.log(error, 'can not get data.');
        }
      }


      vm.init_req();


      // 교수 확정시
      vm.showlectureFix = function(request) {
        var confirm = $mdDialog.confirm()
          .title('교수 확정')
          .textContent('확정시 같은 분반의 이 교수를 제외한 다른 신청내역이 모두 사라집니다. 확정하시겠습니까?')
          .ok('확정')
          .cancel('취소');
        $mdDialog.show(confirm).then(function() {
          vm.lectureFix(request);
        }, function() {
          vm.status = '놔둠';
        });
      };



      vm.lectureFix = function(request) {
        $http.post(('/classes/selectProfessor'), {
          pid: request.professor.uid,
          cid: request.classes_lecture.id
        }).then(function(result) {
          if (result.data.result) {
            vm.showAlert("확정되었습니다.");
            vm.init_req();
          } else {
            vm.showAlert("실패하였습니다.");
          }
        });
      };



      vm.showacceptOffer = function(request) {
        $mdDialog.show({
          controller: requestdialogController,
          templateUrl: 'app/requestprof/divideClass.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          request: request
        }).then(function(answer) {
          vm.status = 'You said the information was "' + answer + '".';
          //$log.log("answer : " + answer);
        }, function() {
          vm.status = 'You cancelled the dialog.';
        });
      };

      function requestdialogController($scope, $mdDialog, $http, $log, request) {

            var dialogcon = $scope;
            dialogcon.request = request;
            //$log.log("request", request);

            dialogcon.semester_list = [{
              text: '1',
              semester: 1
            }, {
              text: '2',
              semester: 2
            }];

            dialogcon.type_list = [
            {
              text: '자유선택',
              type: 0
            }, {
              text: '모듈A',
              type: 1
            }, {
              text: '모듈B',
              type: 2
            }, {
              text: '모듈C',
              type: 3
            }, {
              text: '모듈D',
              type: 4
            },{
              text: '선택안함',
              type: 5
            } ];

            dialogcon.time_list = [{
              text: '관리자가 시간지정',
              time: 0
            }, {
              text: '교수가 시간지정',
              time: 1
            }];

            dialogcon.foreign_list = [{
              text: '자유선택',
              foreign: 0
            }, {
              text: '국제어_자율운영',
              foreign: 1
            }, {
              text: '국제어_지정강좌(학부)',
              foreign: 2
            }, {
              text: '국제어_핵심기초(대학원)',
              foreign: 3
            }, {
              text: '비국제어',
              foreign: 4
            }];

            dialogcon.flipped_list = [{
              text: '자유',
              flipped: 0
            }, {
              text: 'O',
              flipped: 1
            }, {
              text: 'X',
              flipped: 2
            }];

            $http.get('/timemodel/graduate/' + request.classes_lecture.subject.graduate).then(successCallback_time, errorCallback_time);

            function successCallback_time(response) {
              var timemodel_list = response.data;
              // for (var index in timemodel_list) {
              //   var model = timemodel_list[index];
              //   var timemodel = model.lecture_code;
              //   dialogcon.timemodel_list = timemodel_list;
              // }
              dialogcon.timemodel_list = timemodel_list;
            }

            function errorCallback_time(error) {
              $log.log(error, 'can not get data.');
            }

            /* Error */

            dialogcon.str_error = null;
            dialogcon.list_str_error = {
                "number" : "분반 번호를 입력해주세요.",
                "number_type" : "올바르지 않은 분반 번호 형식입니다.",
                "semester" : "학기를 선택해주세요.",
                "foreign" : "국제어 여부를 선택해주세요.",
                "flipped" : "flipped 여부를 선택해주세요.",
                "type" : "강의 수업형태를 선택해주세요.",
                "time" : "시간자유선택 여부를 선택해주세요.",
                "code" : "수업코드를 선택해주세요."
            }

            dialogcon.showError = function(type){
                dialogcon.str_error = dialogcon.list_str_error[type];
                return true;
            }

            /* --- Error --- */

            dialogcon.showAlert = function(title,msg){
                vm.showAlert(title,msg);
            };

            dialogcon.hide = function() {
              $mdDialog.hide();
            };

            //분반 추가
            dialogcon.divideClass = function(number, semester, type, time, timemodel, foreign, flipped, memo) {

                dialogcon.number = number;
                dialogcon.semester = semester;
                dialogcon.type = type;
                dialogcon.time = time;
                dialogcon.foreign = foreign;
                dialogcon.flipped = flipped;
                dialogcon.memo = memo;
                dialogcon.subject = request.classes_lecture.subjects_id;
                dialogcon.professor_id = request.professor.uid;
                dialogcon.classid = request.classes_lecture.id;

                if (dialogcon.time) {
                  dialogcon.time_id = null;
                } else {
                  dialogcon.time_id = timemodel;
                }

                if ((!number && dialogcon.showError("number"))
                  || ((isNaN(number) || Math.floor(number) !== number || number <= 0) && dialogcon.showError("number_type"))
                  || (!semester && dialogcon.showError("semester"))
                  || (foreign==null && dialogcon.showError("foreign"))
                  || (flipped==null && dialogcon.showError("flipped"))
                  || (type==null && dialogcon.showError("type"))
                  || (time==null && dialogcon.showError("time"))
                  || ((time===0 && timemodel==null) && dialogcon.showError("code")))
                  return;

                  $http.post(('/classes/divideClass'), {
                    classno: dialogcon.number,
                    semester: dialogcon.semester,
                    time_id: dialogcon.time_id,
                    graduate: dialogcon.graduate,
                    lecture_type: dialogcon.type,
                    isflipped: dialogcon.flipped,
                    foreign_select: dialogcon.foreign,
                    sid: dialogcon.subject,
                    cid: dialogcon.classid,
                    pid: dialogcon.professor_id,
                    memo: dialogcon.memo

                  }).then(function(result) {
                    if(result.data.result) {
                      vm.showAlert("추가완료", "분반이 추가되었습니다.");
                      vm.init_req();
                  }else vm.showAlert("추가실패", "분반 번호가 중복인지 혹은 입력 항목이 올바른지 확인해주세요.");
                  });

                  $mdDialog.hide();
            }

      }
    
  }

})();

(function() {
  'use strict';

angular
  .module('profsystem')
  .controller('LoginController', LoginController);

//로그인 컨트롤러
function LoginController($log, $rootScope,$scope, $http, $state, $location, $sessionStorage, $document, $window, SHA256) {
    var vm = this;

    vm.login = function () {
      // 백엔드에 인증 시도
      $http.post('/login', {
        uid: vm.uid,
        pw: SHA256(vm.pw)
      }).then(function (result) {
        if(result.data.result) {
          $window.location.assign('/notice');
        }
        else if (vm.uid==null) alert("내선번호를 입력해주세요.");
        else alert("내선번호 또는 비밀번호를 다시 확인해주세요.");

        $sessionStorage.putObject('session',result.data);

      });
    };
    var input = $document[0].getElementById("password_input");

    if(input != null) {
      input.onkeyup = function(e) {
        if(e.keyCode == 13)
            vm.login();
        }
    }

    vm.logout = function () {
        $sessionStorage.remove('session');
        $http.get("/logout").then(function() {
            $state.go('login');
        });
    };
}
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('LayoutController', LayoutController);

    /** @ngInject */
  function LayoutController($rootScope, $state, $scope, $stateParams, $mdSidenav, $http) {

    var vm = this;
    /* 교수 정보 */
    vm.state = $state;
    vm.stateParams = $stateParams;
 

    $http.get("/session").then(function(result) {
      if(result.data.auth == 10)
          vm.user = "admin";
      else if(result.data.auth >=0 && result.data.auth < 10)
          vm.user = "prof";
          $http.get("/getProfCredit").then(function(res){ vm.prof_info = res.data; });
    });




    /* --- 교수 정보 --- */



    vm.toggleLeft = function() {
        $mdSidenav('left').toggle();
    };

    vm.close = function(){
        $mdSidenav('left').close()
    };

    //link에 state이름, title에 사이드바에 띄우는 항목명
    vm.admin = [{
        link: 'notice',
        title: '공지사항',
        icon: 'announcement'
    }, {
        link: 'subject_manage',
        title: '과목',
        icon: 'assignment'
    }, {
        link: 'request_list',
        title: '신청 관리',
        icon: 'settings'
    }, {
        link: 'approveList',
        title: '최종 확정 내역',
        icon: 'dns'
    }, {
        link: 'user_manage',
        title: '사용자',
        icon: 'face'
    }, {
        link: 'timemodel_list',
        title: '수업모형',
        icon: 'event'
    }, {
        link: 'system',
        title: '시스템',
        icon: 'data_usage'
    }];
    vm.prof = [{
        link: 'notice',
        title: '공지사항',
        icon: 'announcement'
    }, {
        link: 'classreq',
        title: '강의 신청',
        icon: 'add_box'
    // }, {
    //     link: 'reqClassList',
    //     title: '신청한 강의리스트',
    //     icon: 'sort'
    }, {
        link: 'fixed_classlist',
        title: '내 강의리스트(최종)',
        icon: 'format_list_bulleted'
    }];
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .config(function($mdThemingProvider) {
      $mdThemingProvider.theme('docs-dark', 'default')
          .primaryPalette('yellow')
          .dark();
    })
    .controller('ClassReqController', ClassReqController);


      /** @ngInject */
      function ClassReqController(day_str, $scope, $window,$sessionStorage, $stateParams, $mdSidenav, $http, $log, $mdDialog, $document, $state, stype_str, lecture_type_str, foreign_select_str, isflipped_str) {

          var vm = this;
          vm.log = $log.log;
          vm.currentState = $state.current.name;
          vm.stype_str = stype_str;
          vm.lecture_type_str = lecture_type_str;
          $log.log(foreign_select_str);
          vm.foreign_select_str = foreign_select_str;
          vm.isflipped_str = isflipped_str;
          vm.session = $sessionStorage.getObject('session');
          vm.day_str = day_str;
          vm.query = {
              order: 'subjects_id',
              limit: 7,
              page: 1
          };
          vm.query2 ={
               order: 'subjects_id',
              limit: 7,
              page: 1

          }

          vm.init_list = function(){
            $http.get('/classes/notSubscribed').then(successCallback_class, errorCallback_class);    //강의신청 리스트(본인이 신청한 것 제외)
            $http.get('/prof/requestClasslist').then(successCallback_requestClass, errorCallback_class);    //신청한 강의 리스트

            function successCallback_class(response) {
              // vm.log(response.data);
              vm.classesList = response.data;
              
            }
            function successCallback_requestClass(response) {
              // vm.log(response.data);
              vm.reqClassList = response.data;
        
            }
            function errorCallback_class(error) {
              $log.log(error, 'can not get data.');
            }

          }

          vm.init_list();


          /* 신청 Dialog */
          vm.show_req = function(class_info) {
            if(class_info.timemodel){

              $mdDialog.show({
                  controller: RequestDialogController,
                  templateUrl: 'app/classreq/dialog_req.html',
                  parent: angular.element($document.body),
                  clickOutsideToClose:true,
                  class_info : class_info,
                  info : class_info,
                  timeinfo: class_info.timemodel.lecture_code || 'empty'
                  //info : class_info
                  //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
              }).then(function(answer) {

                  vm.status = 'You said the information was "' + answer + '".';
                  //$log.log("answer : " + answer);
              }, function() {
                  vm.status = 'You cancelled the dialog.';
              });
            }
            else{

              $mdDialog.show({
                  controller: RequestDialogController,
                  templateUrl: 'app/classreq/dialog_req.html',
                  parent: angular.element($document.body),
                  clickOutsideToClose:true,
                  class_info : class_info,
                  info : class_info,
                  timeinfo: null
                  //info : class_info
                  //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
              }).then(function(answer) {

                  vm.status = 'You said the information was "' + answer + '".';
                  //$log.log("answer : " + answer);
              }, function() {
                  vm.status = 'You cancelled the dialog.';
              });

            }
          };

          /* 수정 Dialog */
          vm.modify_req = function (class_info){
            $mdDialog.show({
              controller: RequestDialogController,
              templateUrl: 'app/classreq/dialog_req.html',
              parent: angular.element($document.body),
              clickOutsideToClose: true,
              class_info: class_info.classes_lecture,
              info: class_info,
              timeinfo: class_info.lecture_code
            }).then(function (answer){
                vm.status = 'You said the information was "' + answer + '".';
                //$log.log("answer : " + answer);
              }, function (){
                vm.status = 'You cancelled the dialog.';
              });
          };
          /* 신청 정보 Dialog */
          vm.show_reqinfo = function(class_info) {
              $mdDialog.show({
                  controller: ReqInfoDialogController,
                  templateUrl: 'app/classreq/dialog_reqinfo.html',
                  parent: angular.element($document.body),
                  clickOutsideToClose:true,
                  class_info : class_info
                  //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
              })
          };

          /* 철회 다이얼로그 */
          vm.show_delete_req = function (class_info){
            var confirm = $mdDialog.confirm()
              .title('신청 철회')
              .textContent(class_info.classes_lecture.subjects_id + ' 신청을 철회합니다.')
              .ok('철회')
              .cancel('취소');
            $mdDialog.show(confirm).then(function (){
              vm.delete_req(class_info.id);
            }, function (){
              vm.status = '놔둠';
            });
          };

          vm.delete_req = function (id){
            $http.post(('/prof/cancelRequest'), {
              id: id
            }).then(function (result){
              if (result.data.result){
                alert("철회되었습니다.");
                vm.init_list();
                $window.location.reload();
              }else{
                alert("삭제에 실패하였습니다.");
                //vm.init_subject();
              }
            });
          };

          /* 신청/수정 Dialog Controller */

          function RequestDialogController(day_str, $scope, $mdDialog, class_info, info, timeinfo) {

            var dialogcon = $scope;
            dialogcon.class_info = class_info;
            dialogcon.info = info;
            dialogcon.day_str = day_str;
            dialogcon.timeinfo = timeinfo;
            //vm.log(dialogcon.class_info);

              //error
            dialogcon.str_error = null;
            dialogcon.list_str_error = {
              'lecture_type' : '6-Module 선택해주세요.',
              'lecture_code' : '수업 모형을 선택해주세요.'
            };

            dialogcon.showError = function(type){
              dialogcon.str_error = dialogcon.list_str_error[type];
              return true;
            };

            dialogcon.showAlert = function(title,msg){ vm.showAlert(title,msg); };

              dialogcon.lecture_type_list = [];
              vm.lecture_type_str.forEach(function(value, index){
                  if(index != 0){
                    dialogcon.lecture_type_list.push({
                      text: value,
                      lecture_type: index
                    });
                  }
              });

              dialogcon.foreign_select_str = [];
              vm.foreign_select_str.forEach(function(value, index){
                  if(index != 0){
                    dialogcon.foreign_select_str.push({
                      text: value,
                      foreign_select: index
                    });
                  }
              });
              
              dialogcon.isflipped_str = [];
              vm.isflipped_str.forEach(function(value, index){
                  if(index != 0){
                    dialogcon.isflipped_str.push({
                      text: value,
                      isflipped: index
                    });
                  }
              });
          /* 신청 교수 불러오기 */

          $http.get('/classes/requestedProfessor/' + class_info.id).then(successCallback_reqprof, errorCallback_reqprof);

          function successCallback_reqprof(response) {

              var reqprof = response.data;
              var list_reqprof = [];
              //$log.log(reqprof);

              for (var index in reqprof){
                  list_reqprof.push(reqprof[index].professor.name);
                  //$log.log(reqprof[index].professor.name);
              }

              dialogcon.class_info.reqprof = (list_reqprof.join(',')!='')?list_reqprof.join(','):'없음';

          }
          function errorCallback_reqprof(error) {
              $log.log(error, 'can not get data.');
          }

          /* --- 신청 교수 불러오기 --- */

          /* 수업 모형 불러오기 */

          $http.get('/timemodel/graduate/' + class_info.subject.graduate).then(successCallback_timemodel, errorCallback_timemodel);

          function successCallback_timemodel(response) {
              //vm.log(response.data);
              dialogcon.timemodel = response.data;

          }
          function errorCallback_timemodel(error) {
              $log.log(error, 'can not get data.');
          }

          /* --- 수업 모형 불러오기 --- */

          dialogcon.hide = function() {
              $mdDialog.hide();
          };

          /*
          dialogcon.cancel = function() {
              $mdDialog.cancel();
          };
           */

          //신청 및 수정
          dialogcon.req_class = function(cid, lecture_type, lecture_code, isflipped, foreign_select) {

            //예외처리
            if((!lecture_type && dialogcon.showError('lecture_type'))
                || (!lecture_code && dialogcon.showError('lecture_code'))) return;


            //DB에 맞춰서 값변화
            dialogcon.isflipped = isflipped;
            dialogcon.foreign_select = foreign_select;

            dialogcon.param = {
              isflipped : isflipped,
              lecture_type : lecture_type,
              lecture_code : lecture_code,
              foreign_select: foreign_select,
              classes_id : cid
            };

            $log.log("foreign_type", foreign_select);

            if(dialogcon.info.classes_lecture) dialogcon.param.id = dialogcon.info.id;

              $http.post(('/prof/requestClass'), dialogcon.param).then(function (res) {
                  if(res.data.result) {
                      alert("신청되었습니다.");
                      vm.init_list();
                      $window.location.reload();

                  }else alert("신청에 실패하였습니다.");
              });

              $mdDialog.hide();
          };
      }

      /* --- 신청 Dialog Controller --- */

      /* 신청 정보 Dialog Controller */

      function ReqInfoDialogController($scope, $mdDialog, class_info) {

          var dialogcon = $scope;
          dialogcon.lecture_type_str = vm.lecture_type_str;
          dialogcon.isflipped_str = vm.isflipped_str;
          dialogcon.foreign_select_str = vm.foreign_select_str;
          dialogcon.class_info = class_info;

          dialogcon.query = {
              order: 'professor.uid',
              limit: 5,
              page: 1
          };

          $http.get('/classes/requestedProfessor/' + class_info.id).then(successCallback_reqinfo, errorCallback_reqinfo);

          function successCallback_reqinfo(response) { dialogcon.reqinfo = response.data;}
          function errorCallback_reqinfo(error) { $log.log(error, 'can not get data.');}


          dialogcon.hide = function() { $mdDialog.hide(); };

          /*
           dialogcon.cancel = function() {
           $mdDialog.cancel();
           };
           */

      }

      /* --- 신청 정보 Dialog Controller --- */

  }

})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('fixedClassListController', fixedClassListController);
    
  /** @ngInject */
  function fixedClassListController($rootScope, $scope, $stateParams, $sessionStorage, $mdSidenav, $http, $log, stype_str, lecture_type_str, foreign_select_str, isflipped_str) {
    var vm = this;

      vm.query = {
          order: 'subjects_id',
          limit: 7,
          page: 1
      };

    vm.fixedList = [];
    vm.log = $log.log;
    vm.stateParams = $stateParams;
    vm.session = $sessionStorage.getObject('session');

    vm.stype_str = stype_str;
    vm.lecture_type_str = lecture_type_str;
    vm.foreign_select_str = foreign_select_str;
    vm.isflipped_str = isflipped_str


      $http.get('/prof/prof/classes/'+vm.session.uid).then(successCallback1, errorCallback1);
      function successCallback1(response) {
        //vm.log(response.data);
        vm.fixedList = response.data;
      }
      function errorCallback1(error) {
        vm.log(error, 'can not get data.');
      }
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('UserManageController', UserManageController);

  /** @ngInject */
  function UserManageController($scope, $stateParams, $mdSidenav, $http, $log, $mdDialog, $document) {

    var vm = this;

    vm.query = {
      order: 'uid',
      limit: 7,
      page: 1
    };

    /* Alert Dialog */

    vm.showAlert = function(title,msg) {
        $mdDialog.show(
            $mdDialog.alert()
                //.parent(agular.element(document.querySelector('#popupContainer')))n
                .clickOutsideToClose(true)
                .title(title)
                .textContent(msg)
                .ariaLabel('Alert Dialog')
                .ok("확인")
        );
    };

    /* --- Alert Dialog --- */

    // 사용자 리스트 초기화 함수
    vm.init_user = function() {
      $http.get('/prof').then(successCallback, errorCallback);

      function successCallback(response) {
        //소속 초기화용
        vm.user_info = response.data;
      }

      function errorCallback(error) {
       vm.$log.log(error, 'can not get data.');
      }
    };

    vm.init_user();

    /* 사용자 추가 Dialog */

    vm.show_plus = function() {
      $mdDialog.show({
        controller: ProfDialogController,
        templateUrl: 'app/excel/add_user.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        user_info: {},
        title: ' 사용자 추가'
        //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
        //$log.log("answer : " + answer);
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    };

    /* 사용자 수정 Dialog */

    vm.show_ad = function(user_info) {
      $mdDialog.show({
        controller: ProfDialogController,
        templateUrl: 'app/excel/edit_user.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals:{user_info: user_info},
        title: user_info.uid + ' 사용자 수정'
        //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
        //$log.log("answer : " + answer);
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    };

    /* 사용자 삭제 */

    vm.show_delete = function(user_info) {
      var confirm = $mdDialog.confirm()
        .title('사용자 삭제')
        .textContent('내선번호 ' + user_info.uid + '의 사용자를 영구적으로 삭제합니다.')
        .ok('삭제')
        .cancel('취소');

      $mdDialog.show(confirm).then(function() {
        vm.delete_user(user_info);
      }, function() {
        vm.status = '놔둠';
      });
    }

    vm.delete_user = function(user_info) {
      $http.post(('/prof/delete'), {
        uid: user_info.uid
      }).then(function(res) {
        if (res.data.result) vm.showAlert("삭제되었습니다.");
        else vm.showAlert("삭제에 실패하였습니다.");
        vm.init_user();
      });
    };

    /*Dialog Controller */

    function ProfDialogController($scope, $mdDialog, $http, SHA256, user_info, title) {

      var dialogcon = $scope;

      // 접근 가능 여부 리스트
      dialogcon.type_list = [{
        text: '가능',
        type: 1
      }, {
        text: '불가능',
        type: 0
      }];

      /* 소속 리스트 초기화 */
      $http.get('/dept').then(function(res) {
        dialogcon.dept_list = res.data;
      });

      //수정 시 기존 정보 입력
      dialogcon.user_info = user_info;
      //dialogcon.user_info.pw = ''; //비밀번호 미표시
      //$log.log("유저인포:",vm.user_info)
      dialogcon.title = title;

      dialogcon.hide = function() {
        $mdDialog.hide();
      };

      //error
      dialogcon.str_error = null;
      dialogcon.list_str_error = {
          "emailform" : "올바르지 않은 이메일 형식입니다.",
          "emaillen" : "이메일은 40글자 미만만 가능합니다.",
          "name" : "이름을 입력해 주십시오.",
          "pw" : "비밀번호를 입력해 주십시오.",
          "uid" : "내선번호를 입력해 주십시오.",
          "uid_type" : "내선번호의 형식이 올바르지 않습니다.",
          "pw_type" : "비밀번호의 형식이 올바르지 않습니다.",
          "dept_key" : "소속을 선택하여 주십시오.",
          "accessible_lecture" : "접근가능여부를 선택하여 주십시오."
      }

      dialogcon.showError = function(type){
          dialogcon.str_error = dialogcon.list_str_error[type];
          return true;
      }

      //교수 추가 및 수정
      dialogcon.post_prof = function(name, uid, pw, email, dept_key,accessible_lecture) {
        if (email && (email.indexOf("@") < 0 && dialogcon.showError("emailform"))
            || (!uid && dialogcon.showError("uid"))
            || (!name && dialogcon.showError("name"))
            || ((isNaN(uid) || Math.floor(uid) != uid || uid <= 0) && dialogcon.showError("uid_type"))
            || (email && email.length > 40 && dialogcon.showError("emaillen"))
            || (pw===null && dialogcon.showError("pw"))
            || ((isNaN(pw) || Math.floor(pw) != pw || pw < 0) && dialogcon.showError("pw_type"))
            || (!dept_key && dialogcon.showError("dept_key"))
            || (accessible_lecture==null && dialogcon.showError("accessible_lecture"))
            )
            return;

        pw = SHA256(String(pw));
        $http.post(('/prof'),{
          uid:uid,
          pw: pw,
          name:name,
          dept_key:dept_key,
          email:email,
          accessible_lecture:accessible_lecture
        }).then(function(res) {
          if (res.data.result) vm.showAlert("성공", "추가/수정되었습니다.");
          else vm.showAlert("실패", "내선번호가 중복인지 혹은 입력항목이 올바른지 확인해주세요");
          vm.init_user();
          $mdDialog.hide();
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('SubjectManageController', SubjectManageController);

  /** @ngInject */
  function SubjectManageController($scope, $stateParams, $mdSidenav, $http, $log, $mdDialog, $document, stype_str) {

    var vm = this;

    vm.query = {
      order: 'professor_id',
      limit: 7,
      page: 1
    };

    vm.stype_str = stype_str;

    $mdDialog.hide();

    /* Alert Dialog */

    vm.showAlert = function(title, msg) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(agular.element(document.querySelector('#popupContainer')))n
        .clickOutsideToClose(true)
        .title(title)
        .textContent(msg)
        .ariaLabel('Alert Dialog')
        .ok("확인")
      );
    };

    /* --- Alert Dialog --- */

    /* Subject 불러오기 */

    vm.init_subject = function() {
      $http.get('/classes/subjectlist').then(successCallback_subject, errorCallback_subject);

      /* Subject 불러오기 */

      function successCallback_subject(response) {

        vm.subject_info = response.data;

      }

      function errorCallback_subject(error) {
        $log.log(error, 'can not get data.');
      }
    }

    vm.init_subject();


    /* --- Subject 불러오기 --- */

    /* 과목 추가 Dialog */

    vm.show_plus = function() {
      $mdDialog.show({
          controller: SubjectDialogController,
          templateUrl: 'app/excel/edit_subject.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          subject_info: {},
          title: '과목 추가',
          butTitle: '추가하기',
          isedit:0
          //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
        })
        .then(function(answer) {
          vm.status = 'You said the information was "' + answer + '".';
          //$log.log("answer : " + answer);
        }, function() {
          vm.status = 'You cancelled the dialog.';
        });
    };

    /* --- 과목 추가 Dialog --- */

    /* 과목 수정 Dialog */

    vm.show_ad = function(subject_info) {
      $mdDialog.show({
          controller: SubjectDialogController,
          templateUrl: 'app/excel/edit_subject.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          subject_info: subject_info,
          title: '과목 수정',
          butTitle: '수정하기',
          isedit:1
          //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
        })
        .then(function(answer) {
          vm.status = 'You said the information was "' + answer + '".';
          //$log.log("answer : " + answer);
        }, function() {
          vm.status = 'You cancelled the dialog.';
        });
    };

    /* --- 과목 수정 Dialog --- */

    /* 과목 삭제 */

    vm.show_delete = function(subject_info) {
      var confirm = $mdDialog.confirm()
        .title('과목 삭제')
        .textContent(subject_info.id + ' 강의를 영구적으로 삭제합니다.')
        .ok('삭제')
        .cancel('취소');

      $mdDialog.show(confirm).then(function() {
        vm.delete_subject(subject_info);
      }, function() {
        vm.status = '놔둠';
      });
    }

    vm.delete_subject = function(subject_info) {
      $http.post(('/classes/deleteSubject'), {
        sid: subject_info.id
      }).then(function(result) {
        if (result.data.result) {
          vm.showAlert("삭제되었습니다.");
          vm.init_subject();
        } else {
          vm.showAlert("삭제에 실패하였습니다.");
          vm.init_subject();
        }
      });
    };

    /* --- 과목 삭제 --- */




    /*Dialog Controller */

    function SubjectDialogController($scope, $mdDialog, $http, subject_info, title, butTitle, isedit) {

      var dialogcon = $scope;

      /* 과목구분 교양: 0, 전공코어: 1, 전공심화: 2, 실험실습: 3, 전공(대학원): 4 */

      dialogcon.stype_list = [{
        text: '교양',
        stype: 0
      }, {
        text: '전공코어',
        stype: 1
      }, {
        text: '전공심화',
        stype: 2
      }, {
        text: '실험실습',
        stype: 3
      }, {
        text: '전공(대학원)',
        stype: 4
      }];

      /* --- 과목 구분--- */
      /* 학부/대학원 */

      dialogcon.graduate_list = [{
        text: '학부',
        graduate: 1
      }, {
        text: '대학원',
        graduate: 2
      }];

      /* --- 학부/대학원 --- */

      //수정 시 기존 정보 입력
      dialogcon.subject_info = subject_info;
      dialogcon.title = title;
      dialogcon.butTitle = butTitle;
      dialogcon.isedit = isedit;

      /* Error */

      dialogcon.str_error = null;
      dialogcon.list_str_error = {
        "id": "학수번호를 입력해주세요.",
        "name": "과목명을 입력해주세요.",
        "credit": "학점을 입력해주세요.",
        "credit_type": "올바르지 않은 학점 형식입니다.",
        "timeunit": "시수를 입력해주세요.",
        "timeunit_type": "올바르지 않은 시수 형식입니다.",
        "graduate": "학부/대학원을 선택해주세요.",
        "stype": "강의 종류를 선택해주세요."
      }

      dialogcon.showError = function(type) {
        dialogcon.str_error = dialogcon.list_str_error[type];
        return true;
      }

      /* --- Error --- */

      //학수번호 수정 못함
      if (dialogcon.subject_info.id != null) {
        dialogcon.checked = true;
      } else {
        dialogcon.checked = false;
      }

      dialogcon.showAlert = function(title, msg) {
        vm.showAlert(title, msg);
      }

      dialogcon.hide = function() {
        $mdDialog.hide();
        vm.init_subject();
      };

      //과목 추가 및 수정
      dialogcon.post_subject = function(id, name, credit, timeunit, graduate, stype, isedit) {

        if ((!id && dialogcon.showError("id")) ||
          (!name && dialogcon.showError("name")) ||
          (!credit && dialogcon.showError("credit")) ||
          ((isNaN(credit) || Math.floor(credit) !== credit || credit <= 0) && dialogcon.showError("credit_type")) ||
          (!timeunit && timeunit !== 0 && dialogcon.showError("timeunit")) ||
          ((isNaN(timeunit) || timeunit < 0 || (timeunit > 0 && Math.floor(timeunit) !== timeunit)) && dialogcon.showError("timeunit_type")) ||
          (!graduate && dialogcon.showError("graduate")) ||
          (!stype && stype !== 0 && dialogcon.showError("stype")))
          return;

        if (isedit==0) {
          for (var a in vm.subject_info) {
            if (vm.subject_info[a].id === id) {
              dialogcon.str_error = "이미 존재하는 학수번호 입니다";
              return;
            }
          }
        }

        $http.post('/classes/modifySubject', {
          id: id,
          name: name,
          credit: credit,
          timeunit: timeunit,
          graduate: graduate,
          stype: stype
        }).then(function(res) {
          if (res.data.result) vm.showAlert('성공', "추가/수정되었습니다.");
          else dialogcon.str_error = "추가에 실패하였습니다.\n학수번호가 중복인지 혹은 입력항목이 올바른지 확인해주세요.";
        });
        vm.init_subject();

        $mdDialog.hide();

      };
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('RequestListController', RequestListController);

  /** @ngInject */
  function RequestListController($scope, $stateParams, $mdSidenav, $http, $log, $mdDialog, $document, stype_str, lecture_type_str, foreign_select_str, isflipped_str) {
    var vm = this;

    vm.stype_str = stype_str;
    vm.lecture_type_str = lecture_type_str;
    vm.foreign_select_str = foreign_select_str;
    vm.isflipped_str = isflipped_str;
    vm.request_info = [];
    vm.$log = $log;
    vm.stateParams = $stateParams;

    vm.query = {
        order: 'subjects_id',
        limit: 7,
        page: 1
    };

    vm.dept_key_str = {
      'CSE' : "컴퓨터공학과",
      'ECE' : "전자전기컴퓨터공학과",
      'EEE' : "전자전기공학부",
      'SSE' : "반도체시스템공학과",
      'SWE' : "소프트웨어학과",
      'CSC' : "전자전기+반도체시스템공학",
      'ESC' : "컴퓨터공학+반도체시스템공학",
      'DMC' : "DMC공학과",
      'ENS' : "에너지시스템공학협동과정",
      'ESW' : "임베디드소프트웨어학과",
      'MCE' : "이동통신전력전자공학과",
      'MSE' : "IT융합학과",
      'PSE' : "태양광시스템공학협동과정",
      'SDE' : "반도체디스플레이공학과"
    }

    /* Alert Dialog */

    vm.showAlert = function(title,msg) {
        $mdDialog.show(
            $mdDialog.alert()
                //.parent(agular.element(document.querySelector('#popupContainer')))n
                .clickOutsideToClose(true)
                .title(title)
                .textContent(msg)
                .ariaLabel('Alert Dialog')
                .ok("확인")
        );
    };

    $http.get('/classes/classlist/class/' + vm.stateParams.class_id).then(successCallback_class, errorCallback_class);

    function successCallback_class(response) {
      vm.stateParams.title = response.data.subjects_id + " (" + response.data.classno + ") 신청 교수";
    }

    function errorCallback_class(error) {
      $log.log(error, 'can not get data.');
    }   

    /* --- Alert Dialog --- */

    // 분반목록 불러오기
    vm.init_req = function() {
        $http.get(('/classes/requestedProfessor/' + vm.stateParams.class_id)).then(successCallback_request, errorCallback_request);

        function successCallback_request(response) {
            vm.request_info = response.data;
            if (response.data[0] == null) {
              vm.message = "신청한 교수님이 없습니다.";
            }
        }
        function errorCallback_request(error) {
            $log.log(error, 'can not get data.');
        }
    }
    vm.init_req();
    vm.showlectureFix = function(request) {
      var confirm = $mdDialog.confirm()
        .title('교수 확정')
        .textContent('확정시 같은 분반의 이 교수를 제외한 다른 신청내역이 모두 사라집니다. 확정하시겠습니까?')
        .ok('확정')
        .cancel('취소');
      $mdDialog.show(confirm).then(function() {
        vm.lectureFix(request);
      }, function() {
        vm.status = '놔둠';
      });
    };

    //주의! 같은 게 requers.controller.js에도 존재....
    vm.lectureFix = function(request) {
      $http.post(('/classes/selectProfessor'), {
        pid: request.professor.uid,
        cid: request.classes_lecture.id
      }).then(function(result) {
        if (result.data.result) {
          vm.showAlert("확정되었습니다.");
          vm.init_req();
        } else {
          vm.showAlert("실패하였습니다.");
        }
      });
    };
    vm.showacceptOffer = function(request) {
      $mdDialog.show({
        controller: requestdialogController,
        templateUrl: 'app/requestprof/divideClass.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        request: request
      }).then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
        $log.log("answer : " + answer);
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    };

    function requestdialogController($scope, $mdDialog, $http, $log, request) {

      var dialogcon = $scope;
      dialogcon.request = request;
      //$log.log("request",request);

      dialogcon.semester_list = [{
        text: '1',
        semester: 1
      }, {
        text: '2',
        semester: 2
      }];

      dialogcon.type_list = [
      {
        text : '자유선택',
        type: 0
      }, {
        text : '모듈A',
        type: 1
      }, {
        text : '모듈B',
        type: 2
      }, {
        text : '모듈C',
        type: 3
      }, {
        text : '모듈D',
        type: 4
      },{
        text : '선택안함',
        type: 5
      }];

      dialogcon.time_list = [{
          text : '관리자가 시간지정',
          time: 0
      }, {
          text : '교수가 시간지정',
          time: 1
      }];

      dialogcon.foreign_list = [{
        text: '자유선택',
        foreign: 0
      }, {
        text: '국제어_자율운영',
        foreign: 1
      }, {
        text: '국제어_지정강좌(학부)',
        foreign: 2
      }, {
        text: '국제어_핵심기초(대학원)',
        foreign: 3
      }, {
        text: '비국제어',
        foreign: 4
      }];

      dialogcon.flipped_list = [{
        text: '자유',
        flipped: 0
      }, {
        text: 'O',
        flipped: 1
      }, {
        text: 'X',
        flipped: 2
      }];

      $http.get('/timemodel/graduate/' + request.classes_lecture.subject.graduate).then(successCallback_time, errorCallback_time);
      function successCallback_time(response) {
        var timemodel_list = response.data;
        // for (var index in timemodel_list) {
        //   var model = timemodel_list[index];
        //   var timemodel = model.lecture_code;
        // }
        dialogcon.timemodel_list = timemodel_list;
      }

      function errorCallback_time(error) {
        $log.log(error, 'can not get data.');
      }

        /* Error */

        dialogcon.str_error = null;
        dialogcon.list_str_error = {
            "number" : "분반 번호를 입력해주세요.",
            "number_type" : "올바르지 않은 분반 번호 형식입니다.",
            "semester" : "학기를 선택해주세요.",
            "foreign" : "국제어 여부를 선택해주세요.",
            "flipped" : "flipped 여부를 선택해주세요.",
            "type" : "강의 수업형태를 선택해주세요.",
            "time" : "시간자유선택 여부를 선택해주세요.",
            "code" : "수업코드를 선택해주세요."
        }

        dialogcon.showError = function(type){
            dialogcon.str_error = dialogcon.list_str_error[type];
            return true;
        }

        /* --- Error --- */

      dialogcon.showAlert = function(title,msg){
          vm.showAlert(title,msg);
      }

      dialogcon.hide = function() {
          $mdDialog.hide();
      };

      //분반 추가
      dialogcon.divideClass = function(number, semester, type, time, timemodel, foreign, flipped, memo) {
        dialogcon.number = number;
        dialogcon.semester = semester;
        dialogcon.type = type;
        dialogcon.time = time;
        dialogcon.foreign = foreign;
        dialogcon.flipped = flipped;
        dialogcon.memo = memo;
        dialogcon.subject= request.classes_lecture.subjects_id;
        dialogcon.professor_id = request.professor.uid;
        dialogcon.classid=request.classes_lecture.id;

        if (dialogcon.time) {
            dialogcon.time_id = null;
        }else {
          dialogcon.time_id = timemodel;
        }


        if ((!number && dialogcon.showError("number"))
          || ((isNaN(number) || Math.floor(number) !== number || number <= 0) && dialogcon.showError("number_type"))
          || (!semester && dialogcon.showError("semester"))
          || (foreign==null && dialogcon.showError("foreign"))
          || (flipped==null && dialogcon.showError("flipped"))
          || (type==null && dialogcon.showError("type"))
          || (time==null && dialogcon.showError("time"))
          || ((time===0 && timemodel==null) && dialogcon.showError("code")))
          return;

        $http.post(('/classes/divideClass'), {
          classno: dialogcon.number,
          semester: dialogcon.semester,
          time_id: dialogcon.timemodel,
          graduate: dialogcon.graduate,
          lecture_type: dialogcon.type,
          isflipped: dialogcon.flipped,
          foreign_select: dialogcon.foreign,
          sid : dialogcon.subject,
          cid : dialogcon.classid,
          pid : dialogcon.professor_id,
          memo: dialogcon.memo

        }).then(function(result) {
          if (result.data.result) {
            vm.showAlert("분리되었습니다..");
            vm.init_req();
          } else vm.showAlert("추가 실패하였습니다.");
        });
        $mdDialog.hide();
        
      
      };
    }
  }



})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('ExcelController', ExcelController);
    
  /** @ngInject */
  function ExcelController($scope, $state, $stateParams, $mdDialog, $document, $mdSidenav, $http, $log, $window) {

      var vm = this;
      vm.user_info = [];
      vm.subject_info = [];

      vm.$log = $log;

      /* Alert Dialog */

      vm.showAlert = function(title,msg) {
          $mdDialog.show(
              $mdDialog.alert()
                  //.parent(agular.element(document.querySelector('#popupContainer')))n
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(msg)
                  .ariaLabel('Alert Dialog')
                  .ok("확인")
          );
      };

      // 확인 창 띄우고 닫으면 새로고침
      vm.showAlertReload = function(title,msg) {
          $mdDialog.show(
              $mdDialog.alert()
                  //.parent(agular.element(document.querySelector('#popupContainer')))n
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(msg)
                  .ariaLabel('Alert Dialog')
                  .ok("확인")
          ).finally(function(){
            $window.location.reload();
          });
      };


      /* --- Alert Dialog --- */

      // 파일 다운로드, 출력 링크 걸기
      if (!$stateParams.title.localeCompare("사용자 관리")){
        vm.selectedValue = "/prof/excel/download";
        vm.wantedValue = "/prof/statistics/"
      }else if (!$stateParams.title.localeCompare("과목 관리")){
        vm.selectedValue = "/classes/excel/download";
        vm.wantedValue = "/classes/excel/";
      }


      //---- 파일 업로드 ----//
      vm.fileSelected = function() {
        var file = vm.file;
        vm.$log.log(file);
      }

      // ---- 파일 다운로드 ----//
      var saveByteArray = (function () {
        var a = $document[0].createElement("a");
        $document[0].body.appendChild(a);
        a.style = "display: none";
        return function (data, name) {
           var blob = new Blob(data, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
           url = $window.URL.createObjectURL(blob);
           a.href = url;
           a.download = name;
           a.click();
           $window.URL.revokeObjectURL(url);
        };
     }());

      vm.submit = function () {
        //vm.$log.log('call submit function');
        if (angular.isUndefined(vm.file) || vm.file == null){      // 파일 있는지 확인
            vm.showAlert('파일이 없습니다!');
        }
        else{
            
            if (!$stateParams.title.localeCompare("사용자 관리")){                
                var fd = new FormData();
                fd.append('file', vm.file);
                $http.post('/prof/prof_excel_register', fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).then(function(result) {
                    if(result.data.result){                      
                      vm.showAlertReload(result.data.text);                       
                    }
                    else{
                      vm.showAlert('추가 실패: ' + result.data.text);
                    }                    
                  }, function(error) {
                        vm.$log.log(error);
                        vm.showAlert('실패');
                  });
                
            } else if (!$stateParams.title.localeCompare("과목 관리")){                
                fd = new FormData();
                fd.append('file', vm.file);
                $http.post('/classes/lecture_excel_register', fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).then(function(response) {
                    if(response.data.result){
                      var binary = new Int8Array(response.data.binary.data);
                      saveByteArray([binary], response.data.fileName);
                      
                      vm.showAlertReload('엑셀 업로드가 완료되었습니다. 업로드 결과는 다운로드 된 엑셀 파일을 참고해주세요!');              
                    }
                     else{
                       vm.showAlert('추가 실패: ' + response.data.text);
                     }
                   }, function(error) {
                       vm.$log.log(error);
                       vm.showAlert('추가 실패');
                   });
            }
        }
        // ---- 파일 업로드 끝 ---- //
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('ClassManageController', ClassManageController);
    
  /** @ngInject */
  function ClassManageController($scope, $stateParams, $mdSidenav, $http, $log, $mdDialog, $document, lecture_type_str, foreign_select_str, isflipped_str) {
    var vm = this;
    vm.$log = $log;
    vm.stateParams = $stateParams;
    vm.lecture_type_str = lecture_type_str;
    vm.foreign_select_str = foreign_select_str;
    vm.isflipped_str = isflipped_str;

      vm.query = {
          order: 'classno',
          limit: 7,
          page: 1
      };

    vm.semester_list = [{
        text : '1',
        semester: 1
    }, {
        text : '2',
        semester: 2
    }];

    vm.time_list = [{
        text : '관리자가 시간지정',
        time: 0
    }, {
        text : '교수가 시간지정',
        time: 1
    }];

    /* Alert Dialog */

    vm.showAlert = function(title,msg) {
        $mdDialog.show(
            $mdDialog.alert()
                //.parent(agular.element(document.querySelector('#popupContainer')))n
                .clickOutsideToClose(true)
                .title(title)
                .textContent(msg)
                .ariaLabel('Alert Dialog')
                .ok("확인")
        );
    };

    /* --- Alert Dialog --- */

    $http.get('/classes/subjectlist/' + vm.stateParams.subject_id).then(successCallback_subject, errorCallback_subject);

    function successCallback_subject(response) {
      vm.subject_info = response.data;
    }
    function errorCallback_subject(error) {
      $log.log(error, 'can not get data');
    }

    // 분반목록 불러오기  
    vm.init_class = function() {

        $http.get(('/classes/classlist/' + vm.stateParams.subject_id)).then(successCallback_class, errorCallback_class);
        vm.stateParams.title = vm.stateParams.subject_id + "의 분반 관리";

        function successCallback_class(response) {

          for(var i = 0 ; i < response.data.length ; i++) {
            // if (response.data[i].timemodel.lecture_code == null) {
            //   response.data[i].timemodel.lecture_code = "미선택";
            // }
            if (response.data[i].professor_uid == null) {
                response.data[i].professor_uid = "미확정";
            }else {
                response.data[i].professor_uid = "확정 (" + response.data[i].professor_uid + ")";
            }
            if(response.data[i].time_id == null) {
                response.data[i].time_id = "교수가 선택"
            }else {
                response.data[i].time_id = "관리자가 선택"
            }
          }
            vm.class_info = response.data;
        }
        function errorCallback_class(error) {
            $log.log(error, 'can not get data.');
        }
    }
    vm.init_class();


    vm.show_add = function(subject_info) {
    $mdDialog.show({
        controller: AddDialogController,
        templateUrl: 'app/excel/add_class.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        title: '분반 추가',
        butTitle: '추가하기',
        subject_info : subject_info
        //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
    })
        .then(function(answer) {
            vm.status = 'You said the information was "' + answer + '".';
            //$log.log("answer : " + answer);
        }, function() {
            vm.status = 'You cancelled the dialog.';
        });
    };


    vm.show_edit = function(subject_info, class_info) {
    $mdDialog.show({
        controller: EditDialogController,
        templateUrl: 'app/excel/edit_class.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        title: '분반 수정',
        butTitle: '수정하기',
        subject_info : subject_info,
        class_info : class_info
        //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
    })
        .then(function(answer) {
            vm.status = 'You said the information was "' + answer + '".';
            //$log.log("answer : " + answer);
        }, function() {
            vm.status = 'You cancelled the dialog.';
        });
    };

   
    vm.show_delete = function(class_info){
    var confirm = $mdDialog.confirm()
        .title('분반 삭제')
        .textContent(class_info.classno + ' 분반을 영구적으로 삭제합니다.')
        .ok('삭제')
        .cancel('취소');

    $mdDialog.show(confirm).then(function() {
        vm.delete_class(class_info);
    }, function() {
        vm.status = '놔둠';
    });
    }

    
    vm.delete_class = function(class_info) {
        $http.post(('/classes/deleteClass'), {
          cid: class_info.id
        }).then(function (result) {
            if(result.data.result) {
                vm.showAlert("삭제되었습니다.");
                vm.init_class();
            }else{
                vm.showAlert("삭제에 실패하였습니다.");
                vm.init_class();
            }
        });
    };

    // 분반추가 컨트롤러
    function AddDialogController($scope, $mdDialog, $http, $log, subject_info, title, butTitle) {

        var dialogcon = $scope;

        dialogcon.type_list = [
        {
            text : '자유선택',
            lecture_type: 0
        }, {
            text : '모듈A',
            lecture_type: 1
        }, {
            text : '모듈B',
            lecture_type: 2
        }, {
            text : '모듈C',
            lecture_type: 3
        }, {
            text : '모듈D',
            lecture_type: 4
        },  {
            text : '선택안함',
            lecture_type: 5
        }
        ];

        dialogcon.foreign_list = [{
            text : '자유선택',
            foreign_select: 0
        }, {
            text : '국제어_자율운영',
            foreign_select: 1
        }, {
            text : '국제어_지정강좌(학부)',
            foreign_select: 2
        }, {
            text : '국제어_핵심기초(대학원)',
            foreign_select: 3
        }, {
            text : '비국제어',
            foreign_select: 4
        }];

        dialogcon.flipped_list = [{
            text : '자유',
            isflipped: 0
        }, 
        {
            text : 'Flip',
            isflipped: 1
        },
        {
            text : 'PBL',
            isflipped: 2
        },
        {
            text : 'WAVE',
            isflipped: 3
        },
        {
            text : '선택안함',
            isflipped: 4
        }
        ];

        dialogcon.semester_list = vm.semester_list;
        dialogcon.time_list = vm.time_list;
        dialogcon.subject_info = subject_info;
        dialogcon.title = title;
        dialogcon.butTitle = butTitle;
        dialogcon.timemodel_list = [];


        $http.get('/timemodel/graduate/' + subject_info.graduate).then(successCallback_time, errorCallback_time);

        function successCallback_time(response) {
          var timemodel_list = response.data;
          dialogcon.timemodel_list = timemodel_list;
        }

        function errorCallback_time(error) {
          $log.log(error, 'can not get data.');
        }

        /* Error */

        dialogcon.str_error = null;
        dialogcon.list_str_error = {
            "number" : "분반 번호를 입력해주세요.",
            "number_type" : "올바르지 않은 분반 번호 형식입니다.",
            "semester" : "학기를 선택해주세요.",
            "foreign" : "국제어 여부를 선택해주세요.",
            "flipped" : "flipped 여부를 선택해주세요.",
            "type" : "강의 수업형태를 선택해주세요.",
            "time" : "시간자유선택 여부를 선택해주세요.",
            "code" : "수업코드를 선택해주세요."
        }

        dialogcon.showError = function(type){
            dialogcon.str_error = dialogcon.list_str_error[type];
            return true;
        }

        /* --- Error --- */

        dialogcon.showAlert = function(title,msg){
            vm.showAlert(title,msg);
        }

        dialogcon.hide = function() {
            $mdDialog.hide();
        };

        //분반 추가
        dialogcon.add_class = function(classno, semester, foreign_select, lecture_type, isflipped, time, timemodel, memo) {

            dialogcon.subjects_id = subject_info.id;
            dialogcon.classno = classno;
            dialogcon.semester = semester;
            dialogcon.foreign_select = foreign_select;
            dialogcon.lecture_type = lecture_type;
            dialogcon.isflipped = isflipped;
            dialogcon.time = time;
            dialogcon.time_id = timemodel;
            dialogcon.memo = memo;

            if (dialogcon.time) {
                dialogcon.time_id = null;
            }else {
                dialogcon.time_id = timemodel;
            }

            if ((!classno && dialogcon.showError("number"))
                  || ((isNaN(classno) || Math.floor(classno) !== classno || classno <= 0) && dialogcon.showError("number_type"))
                  || (!semester && dialogcon.showError("semester"))
                  || (foreign_select==null && dialogcon.showError("foreign"))
                  || (isflipped==null && dialogcon.showError("flipped"))
                  || (lecture_type==null && dialogcon.showError("type"))
                  || (time==null && dialogcon.showError("time"))
                  || ((time===0 && timemodel===null) && dialogcon.showError("code")))
                  return;

              $http.post(('/classes/insertClass'), {

                  subjects_id : dialogcon.subjects_id,
                  classno : dialogcon.classno,
                  semester : dialogcon.semester,
                  foreign_select : dialogcon.foreign_select,
                  lecture_type : dialogcon.lecture_type,
                  isflipped : dialogcon.isflipped,
                  time_id : dialogcon.time_id,
                  memo : dialogcon.memo

              }).then(function (result) {
                  if(result.data.result) {
                      vm.showAlert("추가완료", "분반이 추가되었습니다.");
                      vm.init_class();
                  }else vm.showAlert("추가실패", "분반 번호가 중복인지 혹은 입력 항목이 올바른지 확인해주세요.");
              });
            
            $mdDialog.hide();
        };
    }


    // 분반 수정 컨트롤러
    function EditDialogController($scope, $mdDialog, $http, $log, subject_info, class_info, title, butTitle) {

        var dialogcon = $scope;
        dialogcon.id = class_info.id;

        dialogcon.type_list = [
        {
            text : '자유선택',
            lecture_type: 0
        }, {
            text : '모듈A',
            lecture_type: 1
        }, {
            text : '모듈B',
            lecture_type: 2
        }, {
            text : '모듈C',
            lecture_type: 3
        }, {
            text : '모듈D',
            lecture_type: 4
        },{
            text : '선택안함',
            lecture_type: 5
        }];

        dialogcon.foreign_list = [{
            text : '자유선택',
            foreign_select: 0
        }, {
            text : '국제어_자율운영',
            foreign_select: 1
        }, {
            text : '국제어_지정강좌(학부)',
            foreign_select: 2
        }, {
            text : '국제어_핵심기초(대학원)',
            foreign_select: 3
        }, {
            text : '비국제어',
            foreign_select: 4
        }];

        dialogcon.flipped_list = [{
            text : '자유',
            isflipped: 0
        }, 
        {
            text : 'Flip',
            isflipped: 1
        },
        {
            text : 'PBL',
            isflipped: 2
        },
        {
            text : 'WAVE',
            isflipped: 3
        },
        {
            text : '선택안함',
            isflipped: 4
        }];

        dialogcon.semester_list = vm.semester_list;
        dialogcon.time_list = vm.time_list;
        dialogcon.subject_info = subject_info;
        dialogcon.class_info = class_info;
        dialogcon.title = title;
        dialogcon.butTitle = butTitle;
        dialogcon.timemodel_list = [];

        $http.get('/timemodel/graduate/' + subject_info.graduate).then(successCallback_time, errorCallback_time);

        function successCallback_time(response) {
          var timemodel_list = response.data;
          dialogcon.timemodel_list = timemodel_list;
        }

        function errorCallback_time(error) {
          $log.log(error, 'can not get data.');
        }

        /* Error */

        dialogcon.str_error = null;
        dialogcon.list_str_error = {
            "number" : "분반 번호를 입력해주세요.",
            "number_type" : "올바르지 않은 분반 번호 형식입니다.",
            "semester" : "학기를 선택해주세요.",
            "foreign" : "국제어 여부를 선택해주세요.",
            "flipped" : "flipped 여부를 선택해주세요.",
            "type" : "강의 수업형태를 선택해주세요.",
            "time" : "시간자유선택 여부를 선택해주세요.",
            "code" : "수업코드를 선택해주세요."
        }

        dialogcon.showError = function(type){
            dialogcon.str_error = dialogcon.list_str_error[type];
            return true;
        }

        /* --- Error --- */

        dialogcon.showAlert = function(title,msg){
            vm.showAlert(title,msg);
        }

        dialogcon.hide = function() {
            $mdDialog.hide();
        };

        //분반 수정
        dialogcon.edit_class = function(classno, semester, foreign_select, lecture_type, isflipped, time, timemodel, memo) {

            dialogcon.subjects_id = subject_info.id;
            dialogcon.classno = classno;
            dialogcon.semester = semester;
            dialogcon.foreign_select = foreign_select;
            dialogcon.lecture_type = lecture_type;
            dialogcon.isflipped = isflipped;
            dialogcon.time = time;
            dialogcon.time_id = timemodel;
            dialogcon.memo = memo;

            if (dialogcon.time) {
                dialogcon.time_id = null;
            }else {
                dialogcon.time_id = timemodel;
            }


            if ((!classno && dialogcon.showError("number"))
                  || ((isNaN(classno) || Math.floor(classno) !== classno || classno <= 0) && dialogcon.showError("number_type"))
                  || (!semester && dialogcon.showError("semester"))
                  || (foreign_select==null && dialogcon.showError("foreign"))
                  || (isflipped==null && dialogcon.showError("flipped"))
                  || ((lecture_type==null && lecture_type!=0) && dialogcon.showError("type"))
                  || (time==null && dialogcon.showError("time"))
                  || ((time===0 && timemodel==null) && dialogcon.showError("code")))
                  return;

              $http.post(('/classes/modifyClass'), {

                  id : dialogcon.id,
                  subjects_id : dialogcon.subjects_id,
                  classno : dialogcon.classno,
                  semester : dialogcon.semester,
                  foreign_select : dialogcon.foreign_select,
                  lecture_type : dialogcon.lecture_type,
                  isflipped : dialogcon.isflipped,
                  time_id : dialogcon.time_id,
                  memo : dialogcon.memo

              }).then(function (result) {
                  if(result.data.result) {
                      vm.showAlert("수정완료", "수정이 완료되었습니다.");
                      vm.init_class();
                  }else vm.showAlert("수정실패", "분반 번호가 중복인지 혹은 입력 항목이 올바른지 확인해주세요.");
              });
            
            $mdDialog.hide();
        };

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('ViewController', ViewController);

  /** @ngInject */
  function ViewController($scope, $stateParams, $mdSidenav, $http, $log, $sce) {
    var vm = this;
    vm.$log = $log;
    vm.stateParams = $stateParams;

    if(vm.stateParams.view_id != null) {
      // 작성 시간 축약 후 글 데이터 불러오기
      $http.get('/board/postView/'+vm.stateParams.view_id).then(function(response) {
        response.data.updatedAt = response.data.updatedAt.split("T")[0];
        response.data.createdAt = response.data.createdAt.split("T")[0];
        vm.text = response.data;
        vm.text.content = $sce.trustAsHtml(response.data.content);
        vm.text.updatedAt = vm.text.updatedAt.replace(/-/gi, ". ");
        vm.text.createdAt = vm.text.createdAt.replace(/-/gi, ". ");
      });

      // 첨부파일 다운로드
      $http.get('/board/'+vm.stateParams.view_id+'/attachment').then(function(response) {
        for (var i in response.data) {
          response.data[i].path = response.data[i].path.replace(/\\/gi,"/");
          response.data[i].downloadUrl = '/board/filedown/' + vm.stateParams.view_id + '/' + encodeURIComponent(response.data[i].name);
      //    console.log(response.data[i].path);
        }
        for(i = 1; i < 3; i++)
          vm.files = response.data;
   /*  for(var i = 1; i < response.data.length; i++) {
          if(vm.files[i] != null) {
            vm.files[0] = vm.files[i];
            if(i+1 != response.data.length)
              vm.files[1] = vm.files[i+1];
          }
        } */
      });

      // vm.selected = "/board/filedown/"+vm.stateParams.view_id+"/"+vm.files[0].name;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('NoticeController', NoticeController);

  /** @ngInject */
  function NoticeController($scope, $stateParams, $mdSidenav, $http, $log, $state) {
    var vm = this;
    vm.$log = $log;
    vm.stateParams = $stateParams;

      vm.query = {
          order: -1 * 'id',
          limit: 7,
          page: 1
      };

    // 사용자 구분
    $http.get('/session').then(successCallback, errorCallback);
    function successCallback(response){
      //vm.$log.log(response);
      if(response.data.auth==10) vm.state = "admin";
      else if(response.data.auth<10 && response.data.auth >= 0) vm.state = "prof";
    }
    function errorCallback(error) {
      vm.$log.log(error, 'can not get data.');
    }

    // 글 목록 가져오기
    $http.get('/board/1/board_post').then(function(response) {
      for(var i=0; i<response.data.length; i++) {
        response.data[i].updatedAt = response.data[i].updatedAt.split("T")[0];
        response.data[i].createdAt = response.data[i].createdAt.split("T")[0];
      }
      vm.notices = response.data;
    });

    // 조회수
    vm.click = function(id) {
      $http.post('/board/postcnt', {
        post_id: id
      });
    }

    // 글 작성 페이지로 이동
    vm.mv_write = function(){
      $state.go('write');
    }

    // 글 삭제
    vm.delete = function(board_id, id){
      var cf = confirm("삭제하시겠습니까?");
      if (cf) {
        $http.post('/board/'+board_id+'/postDelete/'+id);
        $http.post('/board/filedelete/'+id);
        alert('게시글이 삭제되었습니다.');
        location.reload();
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('BoardController', BoardController);

  /** @ngInject */
  function BoardController($scope, $stateParams, $mdSidenav, $http, $log, $location, $state, Upload) {
    var vm = this;
    vm.$log = $log;
    vm.stateParams = $stateParams;

    //var editor = CKEDITOR.replace('editor');
    // 글 작성
    /*
    vm.write = function(board_id){
      $http.post('/board/'+board_id+'/postWrite', {
        title: vm.title,
        contents: editor.getData()
      }).then(function(){
        alert('글 업로드 성공');
        $state.go('notice');
      })
    }
    */
    // ckeditor
    vm.options = {
      language: 'en',
      allowedContent: true,
      entities: false
    };

    // Called when the editor is completely ready.
    vm.onReady = function () {
      // ...
    };

    vm.initModify = function () {
      if(vm.stateParams.modify_id != null) {
        // 글 데이터 불러오기
        $http.get('/board/postView/'+vm.stateParams.modify_id).then(function(response) {
          if(response.data.error) {
            alert('글이 존재하지 않습니다.');
          }
          vm.pre_contents = response.data;
       //   console.log(vm.pre_contents);
        })

        // 첨부파일 데이터 가져오기
        $http.get('/board/'+vm.stateParams.modify_id+'/attachment').then(function(response) {
          vm.pre_files = response.data;
          vm.pre_file1 = response.data[0];
          vm.pre_file2 = response.data[1];
          if(response.data.length == 1) {
            vm.attIsVisible_1 = true;
            vm.attIsVisible_2 = false;
          } else if(response.data.length == 2) {
            vm.attIsVisible_1 = true;
            vm.attIsVisible_2 = true;
          } else {
            vm.attIsVisible_1 = false;
            vm.attIsVisible_2 = false;
          }
        })
      }
    }

    // 글 작성
    vm.write = function(file1, file2, board_id){
      var fileArr = [];

      if (file1)
        fileArr.push(file1);
      if (file2)
        fileArr.push(file2);

      if (fileArr.length > 0) {
        vm.upload = Upload.upload({
          url: '/board/'+board_id+'/postWrite',
          method: 'POST',
          fields: {
            title : vm.title,
            contents : vm.cont
          },
          file: fileArr
        }).then(function(result){
        if (result.data.result) {
          alert('글 업로드 성공');
           $state.go('notice');
        }
   //       console.log(fileArr);

        });
      }
      else {
        $http.post('/board/'+board_id+'/postWrite', {
          title: vm.title,
          contents: vm.cont
        }).then(function(result){
        if(result.data.result){
          alert('글 업로드 성공');
          $state.go('notice');
        }
        });
      }
  //    console.log(fileArr);
    }

    // 글 수정
    /*
    vm.modify = function(board_id, id) {
      id = vm.stateParams.modify_id;
      $http.post('/board/1/postModify/'+id, {
        name: vm.pre_contents.name,
        content: editor.getData()
      }).then(function() {
        alert('글 수정 완료');
        $state.go('notice');
      })
    }
    */

    vm.delete_file = function(file_id, ordnum) {
      var del = confirm("한번 삭제하면 파일을 되돌릴 수 없습니다. 그래도 삭제하시겠습니까?");
      if (del) {
        $http.post('/board/filedelete/'+file_id);
        alert("파일이 삭제되었습니다.");
        if(ordnum == 1)
          vm.attIsVisible_1 = false;
        else
          vm.attIsVisible_2 = false;
      }
      else
        alert("파일 삭제가 취소되었습니다.");
    }

    // 글 수정
    vm.modify = function(file1, file2, board_id, id){
      id = vm.stateParams.modify_id;

      var fileArr = [];

      if (file1)
        fileArr.push(file1);
      if (file2)
        fileArr.push(file2);

      if(fileArr.length > 0 && fileArr.length < 3){
        //$http.post('/board/filedelete/'+id);
        vm.upload = Upload.upload({
          url: '/board/'+board_id+'/postModify/'+id,
          method: 'POST',
          fields: {
            title: vm.pre_contents.name,
            contents: vm.pre_contents.content
          },
          file: fileArr
        }).then(function() {
          alert('글 수정 완료');
          $state.go('notice');
        });
      }
      else {
        $http.post('/board/'+board_id+'/postModify/'+id, {
          title: vm.pre_contents.name,
          contents: vm.pre_contents.content
        }).then(function() {
          alert('글 수정 완료');
          $state.go('notice');
        })
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .controller('approveListController', approveListController);
    
  /** @ngInject */
  function approveListController($scope, $stateParams, $mdSidenav, $mdDialog, $http, $log, $state, lecture_type_str, foreign_select_str, isflipped_str) {
    var vm = this;
    vm.approveList = [];
    vm.$log = $log;
    vm.lecture_type_str = lecture_type_str;
    vm.foreign_select_str = foreign_select_str;
    vm.isflipped_str = isflipped_str;
    vm.wantedValue = "/classes/finalList";
    
      vm.query = {
          order: 'subjects_id',
          limit: 7,
          page: 1
      };

    $http.get('/classes/approvelist').then(successCallback1, errorCallback1);
    function successCallback1(response) {
      //vm.$log.log(response);
      //index.constants에 선언한 함수 이용하여 가져오는 방식으로 변경
      vm.approveList = response.data;
    }
    function errorCallback1(error) {
      vm.$log.log(error, 'can not get data.');
    }

    vm.delete_dialog = function(approvement){
      var confirm = $mdDialog.confirm()
        .title("확정 분반 삭제")
        .textContent(approvement.subjects_id + '-' + approvement.classno + ' 의 확정기록을 삭제합니다.')
        .ok('삭제')
        .cancel('취소');
      $mdDialog.show(confirm).then(function(){
        vm.delete_approve(approvement);
      });
    };

    vm.delete_approve = function(approvement){
      $http.post('/classes/deleteApprove', {cid: approvement.id}).then(function(res){
        if(res.data.result) alert("확정기록이 정상적으로 삭제되었습니다.");
        else alert("다시 시도해주시기 바랍니다.");
        $state.reload();
      })
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('profsystem')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log) {

        $log.debug('runBlock end');
    }

})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
      $locationProvider.html5Mode(true);
      $stateProvider
      .state('profsystem', {
        views: {
            'header': { templateUrl: 'app/layout/header.html'},
            'sidebar': { templateUrl: 'app/layout/sidebar.html'},
            'content': { template: '<ui-view />'},
            'footer': {templateUrl: 'app/layout/footer.html'}
        }

      })
      .state('prof', {
          parent: 'profsystem',
          params: { user:"prof"}
      })
      .state('admin', {
          parent: 'profsystem',
          params: { user:"admin"}
      })
      .state('notice', {
          parent: 'profsystem',
          url:'/notice',
          templateUrl:'app/board/notice.html',
          controllerAs:'NoticeController',
          params: {title:"공지사항"}
      })
      .state('view', {
          parent: 'profsystem',
          url:'/view/:view_id',
          templateUrl:'app/board/notice_view.html',
          controllerAs:'ViewController',
          params: {title:"공지사항"}
      })
      .state('write', {
          parent: 'admin',
          url:'/write',
          templateUrl:'app/board/write.html',
          controllerAs:'BoardController',
          params: {title:"공지사항"}
      })
      .state('modify', {
          parent: 'admin',
          url:'/modify/:modify_id',
          templateUrl:'app/board/modify.html',
          controllerAs:'BoardController',
          params: {title:"공지사항"}
      })
      .state('fixed_classlist', {
            parent: 'prof',
            url: '/fixed_classlist',
            templateUrl:'app/fixedClassList/fixedClassList.html',
            controllerAs:'fixedClassListController',
            params: {title:"내 강의리스트(최종)"}
      })
      .state('approveList', {
            parent: 'admin',
            url: '/approveList',
            templateUrl:'app/approveList/approveList.html',
            controllerAs:'approveListController',
            params: {title:"최종 확정 내역"}
      })
      .state('timemodel_list', {
          parent: 'admin',
          url: '/timemodel_list',
          templateUrl:'app/timemodel/timemodelList.html',
          controllerAs:'timeModelController',
          params: {title:"수업 모형"}
      })
      .state('request_list', {
          parent: 'admin',
          url: '/request_list',
          templateUrl:'app/requestprof/request.html',
          controllerAs:'RequestController',
          params: {title:"신청 교수 리스트"}
      })
      .state('excel', {
          parent: 'admin',
          templateUrl: 'app/excel/excel.html'
      })
      .state('user_manage', {
          parent: 'excel',
          url: '/user_manage',
          templateUrl: 'app/excel/user_manage.html',
          params: {title:"사용자 관리"}
      })
      .state('add_user', {
          parent: 'admin',
          url: '/add_user',
          templateUrl: 'app/excel/add_user.html',
          params: {title:"사용자 추가"}
      })
      .state('subject_manage', {
          parent: 'excel',
          url: '/subject_manage',
          templateUrl: 'app/excel/subject_manage.html',
          params: {title:"과목 관리"}
      })
      .state('class_manage', {
          parent: 'admin',
          url: '/class_manage/:subject_id',
          templateUrl: 'app/excel/class_list.html',
          controllerAs: 'ClassManageController'
      })
      .state('class_request', {
          parent: 'admin',
          url: '/class_request/:class_id',
          templateUrl: 'app/excel/request_list.html',
          controllerAs: 'RequestListController'
      })
      .state('classreq', {
          parent: 'prof',
          url: '/classreq',
          params: {title: '강의 신청'},
          templateUrl: 'app/classreq/classreq.html',
          controllerAs: 'ClassReqController'
      })
      .state('reqClassList', {
          parent: 'prof',
          url: '/reqclasslist',
          params: {title: '신청한 강의리스트'},
          templateUrl: 'app/classreq/classreq.html'
          //controllerAs: 'ClassReqController'
      })
      .state('login', {
          url: '/login',
          views: {
               'content': { templateUrl: 'app/layout/login.html'},
               'footer': { templateUrl: 'app/layout/footer.html'}
          }
       })
      .state('system', {
        parent: 'admin',
        url: '/system',
        params: {title: '시스템'},
        templateUrl: 'app/system/system.html'
      });

$urlRouterProvider.otherwise('/login');

}

})();

(function() {
    'use strict';

    angular
        .module('profsystem');


})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .constant('stype_str', [
      '교양', '전공코어', '전공심화', '실험실습', '전공(대학원)'
    ])
    .constant('lecture_type_str', [
        '자유선택', '모듈A', '모듈B', '모듈C', '모듈D', '선택안함'
    ])
    .constant('foreign_select_str', [
        '자유선택', '국제어_자율운영', '국제어_지정강좌(학부)', '국제어_핵심기초(대학원)', '비국제어'
    ])
    .constant('isflipped_str', [
        '자유선택', 'Flip', 'PBL', 'WAVE', '선택안함'
    ])
    .constant('day_str', {
      mon : '월',
      tue : '화',
      wed : '수',
      thu : '목',
      fri : '금',
      sat : '토',
      sun : '일'
     })
    .constant('SHA256', function(s){
      var chrsz   = 8;
      var hexcase = 0;

      function safe_add (x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
      }

      function S (X, n) { return ( X >>> n ) | (X << (32 - n)); }
      function R (X, n) { return ( X >>> n ); }
      function Ch(x, y, z) { return ((x & y) ^ ((~x) & z)); }
      function Maj(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)); }
      function Sigma0256(x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)); }
      function Sigma1256(x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)); }
      function Gamma0256(x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)); }
      function Gamma1256(x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)); }
      function core_sha256 (m, l) {

        var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1,
          0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
          0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786,
          0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
          0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147,
          0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
          0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B,
          0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
          0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A,
          0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
          0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);

        var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);

        var W = new Array(64);
        var a, b, c, d, e, f, g, h;
        var T1, T2;

        m[l >> 5] |= 0x80 << (24 - l % 32);
        m[((l + 64 >> 9) << 4) + 15] = l;

        for ( var i = 0; i<m.length; i+=16 ) {
          a = HASH[0];
          b = HASH[1];
          c = HASH[2];
          d = HASH[3];
          e = HASH[4];
          f = HASH[5];
          g = HASH[6];
          h = HASH[7];

          for ( var j = 0; j<64; j++) {
            if (j < 16) W[j] = m[j + i];
            else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);

            T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
            T2 = safe_add(Sigma0256(a), Maj(a, b, c));

            h = g;
            g = f;
            f = e;
            e = safe_add(d, T1);
            d = c;
            c = b;
            b = a;
            a = safe_add(T1, T2);
          }

          HASH[0] = safe_add(a, HASH[0]);
          HASH[1] = safe_add(b, HASH[1]);
          HASH[2] = safe_add(c, HASH[2]);
          HASH[3] = safe_add(d, HASH[3]);
          HASH[4] = safe_add(e, HASH[4]);
          HASH[5] = safe_add(f, HASH[5]);
          HASH[6] = safe_add(g, HASH[6]);
          HASH[7] = safe_add(h, HASH[7]);
        }
        return HASH;
      }

      function str2binb (str) {
        var bin = Array();
        var mask = (1 << chrsz) - 1;
        for(var i = 0; i < str.length * chrsz; i += chrsz) {
          bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i%32);
        }
        return bin;
      }

      function Utf8Encode(string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

          var c = string.charCodeAt(n);

          if (c < 128) {
            utftext += String.fromCharCode(c);
          }
          else if((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          }
          else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }

        }

        return utftext;
      }

      function binb2hex (binarray) {
        var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
        var str = "";
        for(var i = 0; i < binarray.length * 4; i++) {
          str += hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8+4)) & 0xF) +
            hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8  )) & 0xF);
        }
        return str;
      }

      s = Utf8Encode(s);
      return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
    })

})();

(function() {
  'use strict';

  angular
    .module('profsystem')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $mdThemingProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    var customBlueMap = $mdThemingProvider.extendPalette('light-blue', {
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50'],
        '50': 'ffffff'
    });
    $mdThemingProvider.definePalette('customBlue', customBlueMap);
    $mdThemingProvider.theme('default')
        .primaryPalette('customBlue', {
            'default': '500',
            'hue-1': '50'
        })
        .accentPalette('pink');
    $mdThemingProvider.theme('input', 'default')
        .primaryPalette('grey')
  }

})();

angular.module("profsystem").run(["$templateCache", function($templateCache) {$templateCache.put("app/approveList/approveList.html","<md-card ng-controller=\"approveListController as approvecon\" ng-cloak><md-button class=\"md-primary md-raised\" ng-click=approvecon.print(); ng-href={{approvecon.wantedValue}} target=_self>통계 출력</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_approve><thead md-head md-order=approvecon.query.order><tr md-row><th md-column md-numeric md-order-by=semester><span class=title_size style=\"color: red\">학기</span></th><th md-column md-order-by=subject.name><span class=title_size>교과목명</span></th><th md-column md-order-by=subjects_id><span class=title_size>학수번호</span></th><th md-column md-numeric md-order-by=classno><span class=title_size>분반</span></th><th md-column md-order-by=professor.name><span class=title_size>교수</span></th><th md-column md-order-by=lecture_type><span class=title_size>수업형태</span></th><th md-column md-order-by=timemodel.lecture_code><span class=title_size>신청모형</span></th><th md-column md-order-by=\"\"><span class=title_size>삭제</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"approvelist in approvecon.approveList | filter: filter.search | orderBy: approvecon.query.order | limitTo: approvecon.query.limit : (approvecon.query.page -1) * approvecon.query.limit\"><td md-cell ng-if=\"approvelist.semester==1\">{{approvelist.semester}}</td><td md-cell ng-if=\"approvelist.semester==2\" style=\"color: red\">{{approvelist.semester}}</td><td md-cell class=breakall>{{approvelist.subject.name}}</td><td md-cell class=breakall>{{approvelist.subjects_id}}</td><td md-cell>{{approvelist.classno}}</td><td md-cell class=breakall>{{approvelist.professor.name}} ({{approvelist.professor.uid}})</td><td md-cell class=breakall ng-if=\"approvelist.lecture_type!=5\">{{approvecon.lecture_type_str[approvelist.lecture_type]}} {{approvecon.foreign_select_str[approvelist.foreign_select]}} {{approvecon.isflipped_str[approvelist.isflipped]}}</td><td md-cell class=breakall ng-if=\"approvelist.lecture_type==5\">{{approvecon.foreign_select_str[approvelist.foreign_select]}} {{approvecon.isflipped_str[approvelist.isflipped]}}</td><td md-cell class=breakall>{{approvelist.timemodel.lecture_code}}</td><td md-cell class=breakall><md-button ng-click=approvecon.delete_dialog(approvelist)>삭제</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=approvecon.query.limit md-page=approvecon.query.page md-total={{approvecon.approveList.length}} md-page-select md-boundary-links></md-table-pagination></md-card>");
$templateCache.put("app/board/modify.html","<div ng-controller=\"BoardController as board\"><div ng-init=board.initModify() enctype=multipart/form-data><form enctype=multipart/form-data ng-submit=\"board.modify(file1, file2, 1)\"><md-card><div><input type=text class=\"tb10 write_margin1\" ng-model=board.pre_contents.name placeholder=제목><hr class=title_line></div><div class=write_margin2><div ckeditor=options ng-model=board.pre_contents.content ready=onReady()></div></div><div class=write_margin2><br><br><span><h3 class=write_margin2 style=\"display: inline\">첨부파일 목록</h3>(기존 파일 삭제후 새로운 파일을 등록할 수 있습니다.)</span><br><br><div class=write_margin2 ng-show=board.attIsVisible_1>{{board.pre_file1.name}}<md-button type=button ng-click=\"board.delete_file(board.pre_file1.id, 1)\" aria-label=Close><ng-md-icon icon=delete style=color:gray><ng-md-icon></ng-md-icon></ng-md-icon></md-button></div><div class=write_margin2 ng-show=board.attIsVisible_2>{{board.pre_file2.name}}<md-button type=button ng-click=\"board.delete_file(board.pre_file2.id, 2)\" aria-label=Close><ng-md-icon icon=delete style=color:gray><ng-md-icon></ng-md-icon></ng-md-icon></md-button></div><br><div class=att_ ng-show=!board.attIsVisible_1><input type=file ngf-select ng-model=file1 ngf-multiple=false name=file1 ngf-max-size=200MB></div><br><br><div class=att_ ng-show=!board.attIsVisible_2><input type=file ngf-select ng-model=file2 ngf-multiple=false name=file2 ngf-max-size=200MB></div></div></md-card><md-button type=submit style=float:right class=\"md-raised md-primary\">수정하기</md-button></form></div></div>");
$templateCache.put("app/board/notice.html","<md-card ng-controller=\"NoticeController as noticecon\" ng-cloak><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_notice><thead md-head md-order=noticecon.query.order><tr md-row><th md-column md-numeric md-order-by=id><span class=title_size>글 번호</span></th><th md-column md-order-by=name><span class=title_size>제목</span></th><th md-column md-order-by=professor_uid><span class=title_size>작성자</span></th><th md-column md-numeric><span class=title_size>조회수</span></th><th md-column md-order-by=createdAt><span class=title_size>작성일</span></th><th md-column ng-if=\"layout.user==\'admin\'\"><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"notice in noticecon.notices | filter: filter.search | orderBy: noticecon.query.order | limitTo: noticecon.query.limit : (noticecon.query.page -1) * noticecon.query.limit\"><td md-cell class=breakall>{{notice.id}}</td><td md-cell class=breakall><a ui-sref=\"view({ view_id: notice.id })\" ng-click=noticecon.click(notice.id);>{{notice.name}}</a></td><td md-cell class=breakall>{{notice.professor_uid}}</td><td md-cell class=breakall>{{notice.cnt}}</td><td md-cell>{{notice.createdAt}}</td><td md-cell ng-if=\"layout.user==\'admin\'\"><md-button class=md-primary a ui-sref=\"modify({ modify_id: notice.id })\">수정</md-button><md-button class=md-accent ng-click=\"noticecon.delete(1, notice.id)\">삭제</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=noticecon.query.limit md-page=noticecon.query.page md-total={{noticecon.notices.length}} md-page-select md-boundary-links></md-table-pagination><md-button ng-if=\"layout.user==\'admin\'\" class=\"md-raised md-primary\" ng-click=noticecon.mv_write()>글쓰기</md-button></md-card>");
$templateCache.put("app/board/notice_view.html","<div ng-controller=\"ViewController as noticeView\"><div class=view_margin><md-card><table class=table_view><tbody><tr><td class=head_title colspan=6 class=breakall>{{noticeView.text.name}}</td></tr><tr><td class=head_inform colspan=6 nowrap>{{noticeView.text.professor_uid}} | {{noticeView.text.createdAt}} &nbsp;<ng-md-icon icon=visibility class=icon_size size=20></ng-md-icon>{{noticeView.text.cnt}}</td></tr><tr><td colspan=6><div class=\"write_content breakall\" ng-bind-html=noticeView.text.content></div><br><br></td></tr><tr ng-if=\"noticeView.files.length!=\'0\'\"><td class=breakall colspan=6><hr align=center class=download_line><span class=attachment_1>첨부파일 목록</span><span class=attachment_2>({{noticeView.files.length}})</span><md-button ng-repeat=\"file in noticeView.files\"><ng-md-icon icon=file_download style=color:gray></ng-md-icon><a target=_self ng-href={{file.downloadUrl}} download style=color:black>{{file.name}}</a></md-button></td></tr></tbody></table></md-card></div><md-button class=\"md-raised md-primary\" value=\"\" onclick=window.history.back() style=\"float: right\">글 목록</md-button></div>");
$templateCache.put("app/board/write.html","<div ng-controller=\"BoardController as board\"><form enctype=multipart/form-data ng-submit=\"board.write(file1, file2, 1)\"><md-card><div><input type=text class=\"tb10 write_margin1\" ng-model=board.title placeholder=\"제목을 입력하세요.\"><hr class=title_line></div><div class=write_margin2><div ckeditor=options ng-model=board.cont ready=onReady()></div></div><div class=write_margin2><input type=file ngf-select ng-model=file1 ngf-multiple=false name=file1 ngf-max-size=20MB> <input type=file ngf-select ng-model=file2 ngf-multiple=false name=file2 ngf-max-size=20MB></div></md-card><md-button type=submit style=float:right class=\"md-raised md-primary\">등록</md-button></form></div>");
$templateCache.put("app/excel/add_class.html","<md-dialog class=dialog_class><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}<br><br></div><form name=form_add_class><md-input-container><label>분반 번호</label><input required type=number ng-model=class_classno name=input_classno><div ng-messages><div ng-message=required ng-show=\"form_add_class.input_classno.$error[\'required\']\">분반 번호를 입력해주세요.</div><div ng-message=number ng-show=\"form_add_class.input_classno.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container><br><md-input-container flex><label>학기</label><md-select required ng-model=class_semester><md-option ng-repeat=\"item in semester_list\" ng-value=item.semester>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>국제어강의여부</label><md-select required ng-model=class_foreign_select><md-option ng-repeat=\"item in foreign_list\" ng-value=item.foreign_select>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>6-Module</label><md-select required ng-model=class_lecture_type><md-option ng-repeat=\"item in type_list\" ng-value=item.lecture_type>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>flipped강의여부</label><md-select required ng-model=class_isflipped><md-option ng-repeat=\"item in flipped_list\" ng-value=item.isflipped>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>시간자유선택</label><md-select required ng-model=class_time><md-option ng-repeat=\"item in time_list\" ng-value=item.time>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex ng-show=!class_time><label>수업코드(수업모형)</label><md-select required ng-model=class_timemodel><md-option ng-repeat=\"item in timemodel_list\" ng-value=item.id>{{item.lecture_code}}</md-option></md-select></md-input-container><br><md-input-container><label>비고</label><input ng-model=class_memo></md-input-container><br></form></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>취소</md-button><md-button ng-click=\"add_class(class_classno, class_semester, class_foreign_select, class_lecture_type, class_isflipped, class_time, class_timemodel, class_memo)\">{{butTitle}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/excel/add_user.html","<md-dialog class=dialog_user><form ng-cloak name=edituserform><md-toolbar><div class=md-toolbar-tools><h2>사용자 추가</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}</div><br><md-input-container flex><label>내선번호(아이디)</label><input ng-init=\"modify_uid=user_info.uid\" ng-model=modify_uid name=id_input type=number ng-min=1 step=1 required><div ng-messages><div ng-message=required ng-show=\"edituserform.id_input.$error[\'required\']\">내선번호를 입력해주십시오.</div><div ng-message=number ng-show=\"divideClassform.input_classno.$error[\'number\']\">숫자만 입력해주세요.</div><div ng-message=min ng-show=\"divideClassform.input_classno.$error[\'min\']\">1이상의 정수를 입력해주세요.</div><div ng-message=step ng-show=\"divideClassform.input_classno.$error[\'step\']\">정수를 입력해주세요.</div></div></md-input-container><br><md-input-container><label>이름</label><input ng-init=\"modify_name=user_info.name\" ng-model=modify_name name=name_input type=text required><div ng-messages><div ng-message=required ng-show=\"edituserform.name_input.$error[\'required\']\">이름을 입력해주십시오.</div></div></md-input-container><br><md-input-container flex><label>비밀번호</label><input ng-init=\"modify_pw=user_info.pw\" ng-model=modify_pw name=pw_input type=number ng-min=1 step=1 required><div ng-messages><div ng-message=required ng-show=\"edituserform.pw_input.$error[\'required\']\">비밀번호를 입력해주십시오.</div></div></md-input-container><br><md-input-container flex><label>e-mail</label><input ng-init=\"modify_email=user_info.email\" ng-model=modify_email name=email_input></md-input-container><br><md-input-container flex><label>소속</label><md-select ng-init=\"modify_dept_key=user_info.dept_key\" ng-model=modify_dept_key required><md-option ng-repeat=\"item in dept_list\" ng-value=item.dept>{{item.deptname}}</md-option></md-select></md-input-container><br><md-input-container flex><label>접근가능여부</label><md-select ng-init=\"modify_accessible_lecture=user_info.accessible_lecture\" ng-model=modify_accessible_lecture required><md-option ng-repeat=\"item in type_list\" ng-value=item.type>{{item.text}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>취소</md-button><md-button ng-click=\"post_prof(modify_name, modify_uid, modify_pw, modify_email, modify_dept_key, modify_accessible_lecture)\">추가하기</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/excel/class_list.html","<md-card ng-controller=\"ClassManageController as clsmancon\" ng-cloak style=\"padding: 15px\"><md-button class=\"md-raised md-primary\" style=\"width: 10%\" ng-click=clsmancon.show_add(clsmancon.subject_info);>분반 추가</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_classlist><thead md-head md-order=clsmancon.query.order><tr md-row><th md-column md-order-by=classno><span class=title_size>분반</span></th><th md-column md-order-by=semester><span class=title_size style=\"color: red\">학기</span></th><th md-column md-numeric md-order-by=timemodel.lecture_code><span class=title_size>수업모형</span></th><th md-column md-numeric md-order-by=professor_uid><span class=title_size>확정여부</span></th><th md-column md-numeric md-order-by=lecture_type><span class=title_size>수업형태</span></th><th md-column md-order-by=\"\"><span class=title_size>비고</span></th><th md-column md-order-by=\"\"><span class=title_size>신청교수<br>정보</span></th><th md-column md-order-by=\"\"><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"class in clsmancon.class_info | filter: filter.search | orderBy: clsmancon.query.order | limitTo: clsmancon.query.limit : (clsmancon.query.page -1) * clsmancon.query.limit\"><td md-cell>{{class.classno}}</td><td md-cell ng-if=\"class.semester==1\">{{class.semester}}</td><td md-cell ng-if=\"class.semester==2\" style=\"color: red\">{{class.semester}}</td><td md-cell class=breakall>{{class.timemodel.lecture_code?class.timemodel.lecture_code:\"교수 선택\"}}</td><td md-cell>{{class.professor_uid}}</td><td md-cell ng-if=\"class.lecture_type!=5\">{{clsmancon.lecture_type_str[class.lecture_type]}} {{clsmancon.foreign_select_str[class.foreign_select]}} {{clsmancon.isflipped_str[class.isflipped]}}</td><td md-cell ng-if=\"class.lecture_type==5\">{{clsmancon.foreign_select_str[class.foreign_select]}} {{clsmancon.isflipped_str[class.isflipped]}}</td><td md-cell class=breakall>{{class.memo}}</td><td md-cell><md-button class=md-primary ng-click=acceptOffer(); a href=/class_request/{{class.id}}>교수 목록</md-button></td><td md-cell><md-button class=md-primary ng-click=\"clsmancon.show_edit(clsmancon.subject_info, class);\">분반 수정</md-button><md-button class=md-accent ng-click=clsmancon.show_delete(class);>분반 삭제</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=clsmancon.query.limit md-page=clsmancon.query.page md-total={{clsmancon.class_info.length}} md-page-select md-boundary-links></md-table-pagination></md-card>");
$templateCache.put("app/excel/edit_class.html","<md-dialog class=dialog_class><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}<br><br></div><form name=form_edit_class><md-input-container><label>분반 번호</label><input required ng-init=\"edit_classno = class_info.classno\" type=number string-to-number ng-model=edit_classno name=input_classno><div ng-messages><div ng-message=required ng-show=\"form_edit_class.input_classno.$error[\'required\']\">분반 번호를 입력해주세요.</div><div ng-message=number ng-show=\"form_edit_class.input_classno.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container><br><md-input-container flex><label>학기</label><md-select required ng-init=\"edit_semester = class_info.semester\" ng-model=edit_semester><md-option ng-repeat=\"item in semester_list\" ng-value=item.semester>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>국제어강의여부</label><md-select required ng-init=\"edit_foreign_select = class_info.foreign_select\" ng-model=edit_foreign_select><md-option ng-repeat=\"item in foreign_list\" ng-value=item.foreign_select>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>6-Module</label><md-select required ng-init=\"edit_lecture_type = class_info.lecture_type\" ng-model=edit_lecture_type><md-option ng-repeat=\"item in type_list\" ng-value=item.lecture_type>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>flipped강의여부</label><md-select required ng-init=\"edit_isflipped = class_info.isflipped\" ng-model=edit_isflipped><md-option ng-repeat=\"item in flipped_list\" ng-value=item.isflipped>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>시간자유선택</label><md-select required ng-init=\"edit_time = (class_info.timemodel?0:1)\" ng-model=edit_time><md-option ng-repeat=\"item in time_list\" ng-value=item.time>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex ng-show=!edit_time><label>수업코드(수업모형)</label><md-select required ng-init=\"edit_timemodel = class_info.timemodel.id\" ng-model=edit_timemodel><md-option ng-repeat=\"item in timemodel_list\" ng-value=item.id>{{item.lecture_code}}</md-option></md-select></md-input-container><br><md-input-container><label>비고</label><input ng-init=\"edit_memo = class_info.memo\" ng-model=edit_memo></md-input-container><br></form></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>취소</md-button><md-button ng-click=\"edit_class(edit_classno, edit_semester, edit_foreign_select, edit_lecture_type, edit_isflipped, edit_time, edit_timemodel, edit_memo)\">{{butTitle}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/excel/edit_subject.html","<md-dialog class=dialog_subject><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}<br><br></div><form name=form_edit_subject><md-input-container><label>학수번호</label><input required ng-init=\"id = subject_info.id\" ng-model=id ng-disabled=checked name=input_id><div ng-messages><div ng-message=required ng-show=\"form_edit_subject.input_id.$error[\'required\']\">학수번호를 입력해주세요.</div></div></md-input-container><br><md-input-container><label>과목명</label><input required ng-init=\"name = subject_info.name\" ng-model=name name=input_name><div ng-messages><div ng-message=required ng-show=\"form_edit_subject.input_name.$error[\'required\']\">과목명을 입력해주세요.</div></div></md-input-container><br><md-input-container><label>학점</label><input required ng-init=\"credit = subject_info.credit\" ng-model=credit type=number name=input_credit><div ng-messages><div ng-message=required ng-show=\"form_edit_subject.input_credit.$error[\'required\']\">학점을 입력해주세요.</div><div ng-message=number ng-show=\"form_edit_subject.input_credit.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container><br><md-input-container><label>시수</label><input required ng-init=\"timeunit = subject_info.timeunit\" ng-model=timeunit type=number name=input_timeunit><div ng-messages><div ng-message=required ng-show=\"form_edit_subject.input_timeunit.$error[\'required\']\">시수를 입력해주세요.</div><div ng-message=number ng-show=\"form_edit_subject.input_timeunit.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container><br><md-input-container flex><label>학부 / 대학원</label><md-select required ng-init=\"graduate = subject_info.graduate\" ng-model=graduate><md-option ng-repeat=\"item in graduate_list\" ng-value=item.graduate>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>강의 종류</label><md-select required ng-init=\"stype = subject_info.stype\" ng-model=stype><md-option ng-repeat=\"item in stype_list\" ng-if=\"graduate == 1 && item.stype != 4\" ng-value=item.stype>{{item.text}} 강의</md-option><md-option ng-repeat=\"item in stype_list\" ng-if=\"graduate == 2 && item.stype == 4\" ng-value=item.stype>{{item.text}} 강의</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>취소</md-button><md-button ng-click=\"post_subject(id, name, credit, timeunit, graduate, stype, isedit)\">{{butTitle}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/excel/edit_user.html","<md-dialog class=dialog_user><form ng-cloak name=edituserform><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}</div><br><md-input-container flex><label>내선번호(아이디)</label><input ng-init=\"modify_uid=user_info.uid\" ng-model=modify_uid name=id_input readonly type=text></md-input-container><br><md-input-container><label>이름</label><input ng-init=\"modify_name=user_info.name\" ng-model=modify_name name=name_input type=text required><div ng-messages><div ng-message=required ng-show=\"edituserform.name_input.$error[\'required\']\">이름을 입력해주십시오.</div></div></md-input-container><br><md-input-container flex><label>비밀번호</label><input ng-init=\"modify_pw=\'\'\" ng-model=modify_pw name=pw_input type=text></md-input-container><br><md-input-container flex><label>e-mail</label><input ng-init=\"modify_email=user_info.email\" ng-model=modify_email name=email_input></md-input-container><br><md-input-container flex><label>소속</label><md-select ng-init=\"modify_dept_key=user_info.dept_key\" ng-model=modify_dept_key required><md-option ng-repeat=\"item in dept_list\" ng-value=item.dept>{{item.deptname}}</md-option></md-select></md-input-container><br><md-input-container flex><label>접근가능여부</label><md-select ng-init=\"modify_accessible_lecture=user_info.accessible_lecture\" ng-model=modify_accessible_lecture required><md-option ng-repeat=\"item in type_list\" ng-value=item.type>{{item.text}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>취소</md-button><md-button ng-click=\"post_prof(modify_name, modify_uid, modify_pw, modify_email, modify_dept_key, modify_accessible_lecture)\">수정하기</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/excel/excel.html","<md-card ng-controller=\"ExcelController as excel\" style=\"margin-left: 0; margin-right: 0; padding: 15px\" md-theme=\"{{ showDarkTheme ? \'dark-purple\' : \'default\' }}\" md-theme-watch><md-card-title-media layout=column layout-align=\"center none\"><div class=\"md-media-sm card-media\"><md-button class=\"md-primary md-raised\" style=\"margin-right: 0\" ng-click=acceptOffer(); ng-href={{excel.selectedValue}} target=_self>엑셀 양식 다운로드</md-button><md-button class=\"md-primary md-raised\" ng-click=excel.print(); ng-href={{excel.wantedValue}} target=_self>통계 출력</md-button><div style=\"margin-left: 10px\"><span style=\"padding-top: 10px solid #33ccff\">엑셀 입력 :</span><md-button><input aria-label type=file ngf-select ngf-change=excel.fileSelected() ng-model=excel.file name=file id=file class=file-input-hide accept=.xlsx></md-button><md-button type=submit class=md-raised ng-click=excel.submit(); style=\"background-color: white\">입력</md-button></div></div></md-card-title-media><md-card-actions layout=row layout-align=\"start end\" style=\"padding-left : 15px\"></md-card-actions></md-card><md-card style=\"margin-left: 0; margin-right: 0\" md-theme=\"{{ showDarkTheme ? \'dark-orange\' : \'default\' }}\" md-theme-watch><md-card-content layout=column layout-align=\"center none\" data-ui-view style=\"margin-right: 0; margin-left: 0px\"></md-card-content></md-card>");
$templateCache.put("app/excel/request_list.html","<md-card ng-controller=\"RequestListController as reqlistcon\" ng-cloak><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_reqlist><thead md-head md-order=reqlistcon.query.order><tr md-row><th md-column md-order-by=professor_id><span class=title_size>내선번호</span></th><th md-column md-order-by=professor.name><span class=title_size>교수명</span></th><th md-column md-numeric md-order-by=professor.email><span class=title_size>이메일</span></th><th md-column md-numeric md-order-by=professor.dept_key><span class=title_size>소속</span></th><th md-column md-numeric md-order-by=classes_lecture.foreign_select><span class=title_size>수업형태</span></th><th md-column md-order-by=lecture_code><span class=title_size>수업모형</span></th><th md-column md-order-by=createdAt><span class=title_size>신청시간</span></th><th md-column md-order-by=\"\"><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"request in reqlistcon.request_info | filter: filter.search | orderBy: reqlistcon.query.order | limitTo: reqlistcon.query.limit : (reqlistcon.query.page -1) * reqlistcon.query.limit\"><td md-cell class=breakall>{{request.professor_id}}</td><td md-cell class=breakall>{{request.professor.name}}</td><td md-cell class=breakall>{{request.professor.email}}</td><td md-cell class=breakall>{{reqlistcon.dept_key_str[request.professor.dept_key]}}</td><td md-cell ng-if=\"request.lecture_type!=5\">{{reqlistcon.lecture_type_str[request.lecture_type]}} {{reqlistcon.foreign_select_str[request.foreign_select]}} {{reqlistcon.isflipped_str[request.isflipped]}}</td><td md-cell ng-if=\"request.lecture_type==5\">{{reqlistcon.foreign_select_str[request.foreign_select]}} {{reqlistcon.isflipped_str[request.isflipped]}}</td><td md-cell class=breakall>{{request.lecture_code}}</td><td md-cell>{{request.createdAt}}</td><td md-cell><md-button class=md-primary ng-click=reqlistcon.showlectureFix(request);>교수 확정</md-button><md-button class=md-accent ng-click=reqlistcon.showacceptOffer(request);>분반 분리</md-button></td></tr></tbody></table></md-table-container><div class=mes>{{reqlistcon.message}}</div><md-table-pagination md-limit=reqlistcon.query.limit md-page=reqlistcon.query.page md-total={{reqlistcon.request_info.length}} md-page-select md-boundary-links></md-table-pagination></md-card>");
$templateCache.put("app/excel/subject_manage.html","<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=http://www.w3.org/1999/xhtml lang=ko xml:lang=ko><meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"><meta meta charset=utf-8><div ng-controller=\"SubjectManageController as submancon\" ng-cloak><md-button class=md-raised style=\"color: #0099ff; background-color: white\" ng-click=submancon.show_plus();>과목 추가</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_subjectmanage><thead md-head md-order=submancon.query.order><tr md-row><th md-column md-numeric md-order-by=id><span class=title_size>학수번호</span></th><th md-column md-numeric md-order-by=name><span class=title_size>과목명</span></th><th md-column md-order-by=credit><span class=title_size>학점</span></th><th md-column md-order-by=timeunit><span class=title_size>시수</span></th><th md-column md-order-by=graduate><span class=title_size>학부</span></th><th md-column md-order-by=stype><span class=title_size>과목구분</span></th><th md-column md-order-by=\"\"><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"subject in submancon.subject_info | filter: filter.search | orderBy: submancon.query.order | limitTo: submancon.query.limit : (submancon.query.page -1) * submancon.query.limit\"><td md-cell class=breakall>{{subject.id}}</td><td md-cell class=breakall>{{subject.name}}</td><td md-cell>{{subject.credit}}</td><td md-cell>{{subject.timeunit}}</td><td md-cell class=breakall>{{subject.graduate==1?\"학부\":\"대학원\"}}</td><td md-cell class=breakall>{{submancon.stype_str[subject.stype]}}</td><td md-cell><md-button class=md-primary ng-click=submancon.acceptOffer(); a href=/class_manage/{{subject.id}}>분반 관리</md-button><md-button class=md-primary ng-click=submancon.show_ad(subject);>과목 수정</md-button><md-button class=md-accent ng-click=submancon.show_delete(subject)>과목 삭제</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=submancon.query.limit md-page=submancon.query.page md-total={{submancon.subject_info.length}} md-page-select md-boundary-links></md-table-pagination></div></html>");
$templateCache.put("app/excel/user_manage.html","<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=http://www.w3.org/1999/xhtml lang=ko xml:lang=ko><meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"><meta meta charset=utf-8><div ng-controller=\"UserManageController as usercon\" ng-cloak ng-init=init_user()><md-button class=md-raised style=\"color: #0099ff; background-color: white\" ng-click=usercon.show_plus();>사용자 추가</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_user_manage><thead md-head md-order=usercon.query.order><tr md-row><th md-column md-numeric md-order-by=uid><span class=title_size>ID</span></th><th md-column md-order-by=name><span class=title_size>사용자명</span></th><th md-column md-order-by=dept><span class=title_size>소속</span></th><th md-column md-numeric md-order-by=total_assigned><span class=title_size>연간<br>확정학점</span></th><th md-column md-order-by=undrgrdt_assigned><span class=title_size>학부<br>확정학점</span></th><th md-column md-order-by=foreign_assigned><span class=title_size>국제어<br>확정학점</span></th><th md-column><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"user in usercon.user_info | filter: filter.search | orderBy: usercon.query.order | limitTo: usercon.query.limit : (usercon.query.page -1) * usercon.query.limit\"><td md-cell class=breakall>{{user.uid}}</td><td md-cell class=breakall>{{user.name}}</td><td md-cell class=breakall>{{user.dept.deptname}}</td><td md-cell>{{user.total_established}}</td><td md-cell>{{user.undrgrdt_established}}</td><td md-cell>{{user.foreign_established}}</td><td md-cell><md-button ng-click=usercon.show_ad(user); class=md-primary>수정</md-button><md-button ng-click=usercon.show_delete(user) class=md-accent>삭제</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=usercon.query.limit md-page=usercon.query.page md-total={{usercon.user_info.length}} md-page-select md-boundary-links></md-table-pagination></div></html>");
$templateCache.put("app/classreq/classreq.html","<!--신청한 강의 리스트--><div ng-controller=\"ClassReqController as classreq\"><md-card ng-cloak><md-toolbar class=head_card><p class=head_card_text>신청한 강의 리스트</p></md-toolbar><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search1 type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_class><thead md-head md-order=classreq.query.order><tr md-row><th md-column md-numeric md-order-by=semester><span class=title_size style=\"color: red\">학기</span></th><th md-column md-order-by=subject.id><span class=title_size>학수 번호</span></th><th md-column md-order-by=subject.name><span class=title_size>과목명</span></th><th md-column md-numeric md-order-by=classno><span class=title_size>분반</span></th><th md-column md-numeric md-order-by=subject.credit><span class=title_size>학점</span></th><th md-column md-order-by=subject.graduate><span class=title_size>유형</span></th><th md-column md-order-by=subject.stype><span class=title_size>과목구분</span></th><th md-column md-order-by=\"\"><span class=title_size>수업모형</span></th><th md-column md-order-by=lecture_type><span class=title_size>수업형태</span></th><th md-column><span class=title_size>비고</span></th><th md-column class=th_mod><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"reqClass in classreq.reqClassList | filter: filter.search1 | orderBy: classreq.query.order | limitTo: classreq.query.limit : (classreq.query.page -1) * classreq.query.limit\"><td md-cell ng-if=\"reqClass.classes_lecture.semester==1\">{{reqClass.classes_lecture.semester}}</td><td md-cell ng-if=\"reqClass.classes_lecture.semester==2\" style=\"color: red\">{{reqClass.classes_lecture.semester}}</td><td md-cell class=breakall>{{reqClass.classes_lecture.subject.id}}</td><td md-cell class=breakall>{{reqClass.classes_lecture.subject.name}}</td><td md-cell>{{reqClass.classes_lecture.classno}}</td><td md-cell>{{reqClass.classes_lecture.subject.credit}}</td><td md-cell>{{reqClass.classes_lecture.subject.graduate==1?\"학부\":\"대학원\"}}</td><td md-cell>{{classreq.stype_str[reqClass.classes_lecture.subject.stype]}}</td><!--<td md-cell>{{classreq.timemodelParse(reqClass.timemodel.timemodel_times)}}</td>--><td md-cell ng-if=\"reqClass.timemodel_times.length != 0\"><div ng-repeat=\"timemodel in reqClass.timemodel_times\">{{classreq.day_str[timemodel.day]}} {{timemodel.start_time.slice(0,5)}}~{{timemodel.finish_time.slice(0,5)}}</div></td><td md-cell ng-if=\"reqClass.timemodel_times.length == 0\">자유 선택</td><td md-cell ng-if=\"reqClass.lecture_type!=5\">{{classreq.lecture_type_str[reqClass.lecture_type]}}<br>{{classreq.foreign_select_str[reqClass.foreign_select]}}<br>{{classreq.isflipped_str[reqClass.isflipped]}}</td><!--{{classreq.isflipped_str[reqClass.isflipped]}}--><td md-cell ng-if=\"reqClass.lecture_type==5\">{{classreq.foreign_select_str[reqClass.foreign_select]}}<br>{{classreq.isflipped_str[reqClass.isflipped]}}</td><!-- {{classreq.isflipped_str[reqClass.isflipped]}}--><td md-cell class=breakall>{{reqClass.memo}}</td><td md-cell class=td_mod><md-button class=md-primary ng-click=classreq.modify_req(reqClass)>수정</md-button><md-button class=md-accent ng-click=classreq.show_delete_req(reqClass)>철회</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=classreq.query.limit md-page=classreq.query.page md-total=\"{{(classreq.reqClassList | filter: filter.search1).length}}\" md-page-select md-boundary-links></md-table-pagination></md-card><!--강의 신청 리스트--><!-- 학수 번호 / 과목명 / 분반 번호 / 학기 / 학점 / 학부 / 과목구분 / 수업모형 / 확정여부 / 수업형태 / 신청정보 / 비고 / 신청--><md-card ng-cloak><md-toolbar class=head_card><p class=head_card_text>새로운 강의 신청</p></md-toolbar><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search2 type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_class><thead md-head md-order=classreq.query2.order><tr md-row><th md-column md-numeric md-order-by=semester><span class=title_size style=\"color: red\">학기↕</span></th><th md-column md-order-by=subject.id><span class=title_size>학수 번호↕</span></th><th md-column md-order-by=subject.name><span class=title_size>과목명↕</span></th><th md-column md-numeric md-order-by=classno><span class=title_size>분반↕</span></th><th md-column md-numeric md-order-by=subject.credit><span class=title_size>학점↕</span></th><th md-column md-order-by=subject.graduate><span class=title_size>유형↕</span></th><th md-column md-order-by=subject.stype><span class=title_size>과목구분↕</span></th><th md-column md-order-by=\"\"><span class=title_size>수업모형</span></th><th md-column md-order-by=professor_uid><span class=title_size>확정여부↕</span></th><th md-column md-order-by=lecture_type><span class=title_size>수업형태↕</span></th><th md-column><span class=title_size>신청내역</span></th><th md-column><span class=title_size>비고</span></th><th md-column ng-if=\"classreq.currentState==\'classreq\'\" class=th_req><span class=title_size>신청</span></th><th md-column ng-if=\"classreq.currentState==\'reqClassList\'\" class=th_mod><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"class in classreq.classesList | filter: filter.search2 | orderBy: classreq.query2.order | limitTo: classreq.query2.limit : (classreq.query2.page -1) * classreq.query2.limit\"><td md-cell ng-if=\"class.semester==1\">{{class.semester}}</td><td md-cell ng-if=\"class.semester==2\" style=\"color: red\">{{class.semester}}</td><td md-cell class=breakall>{{class.subject.id}}</td><td md-cell class=breakall>{{class.subject.name}}</td><td md-cell>{{class.classno}}</td><td md-cell>{{class.subject.credit}}</td><td md-cell>{{class.subject.graduate==1?\"학부\":\"대학원\"}}</td><td md-cell>{{classreq.stype_str[class.subject.stype]}}</td><td md-cell ng-if=\"class.timemodel.timemodel_times.length != 0 && class.timemodel != null\"><div ng-repeat=\"timemodel in class.timemodel.timemodel_times\">{{classreq.day_str[timemodel.day]}} {{timemodel.start_time.slice(0,5)}}~{{timemodel.finish_time.slice(0,5)}}</div></td><td md-cell ng-if=\"class.timemodel.timemodel_times.length == 0 || class.timemodel == null\">자유 선택</td><td md-cell>{{class.professor_uid?\"확정 (\"+class.professor_uid+\")\":\"미확정\"}}</td><td md-cell ng-if=\"class.lecture_type!=5\">{{classreq.lecture_type_str[class.lecture_type]}} {{classreq.foreign_select_str[class.foreign_select]}} {{classreq.isflipped_str[class.isflipped]}}</td><td md-cell ng-if=\"class.lecture_type==5\">{{classreq.foreign_select_str[class.foreign_select]}} {{classreq.isflipped_str[class.isflipped]}}</td><td md-cell><md-button class=md-accent ng-click=\"classreq.currentState==\'classreq\'?classreq.show_reqinfo(class):classreq.show_reqinfo(class.classes_lecture)\">정보 보기</md-button></td><td md-cell class=breakall>{{class.memo}}</td><td md-cell ng-if=\"classreq.currentState==\'classreq\'\"><md-button class=md-primary ng-click=classreq.show_req(class) ng-disabled=class.professor_uid>신청</md-button></td><td md-cell ng-if=\"classreq.currentState==\'reqClassList\'\" class=td_mod><md-button class=md-primary ng-click=classreq.modify_req(class)>수정</md-button><md-button class=md-accent ng-click=classreq.show_delete_req(class)>철회</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=classreq.query2.limit md-page=classreq.query2.page md-total=\"{{(classreq.classesList | filter: filter.search2).length}}\" md-page-select md-boundary-links></md-table-pagination></md-card></div>");
$templateCache.put("app/classreq/dialog_req.html","<md-dialog style=width:500px><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>강의 신청/수정하기</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><md-content md-theme=docs-dark layout-padding><div style=font-size:1.25em>{{class_info.subject.name}}</div><div style=color:#EAEAEA>학수 번호 : {{class_info.subjects_id}}<br>분반번호 : {{class_info.classno}}<br>학기 : {{class_info.semester}}<br>비고 : {{class_info.memo}}<br>신청 대기자 : {{class_info.reqprof}}</div></md-content><md-divider></md-divider><br><div class=text_warning ng-show=\"str_error != null\">{{str_error}}</div><div class=md-dialog-content style=padding-top:0px><md-input-container class=md-block style=margin-bottom:0px flex><label>6-Module</label><md-select ng-init=\"lecture_type=info.lecture_type\" ng-model=lecture_type ng-disabled=\"class_info.lecture_type!=0\"><md-option ng-repeat=\"item in lecture_type_list\" ng-value=item.lecture_type>{{item.text}}</md-option></md-select></md-input-container><md-input-container class=md-block style=\"margin-top:20px; margin-bottom:0px\" flex><label>수업 모형</label><md-select ng-init=\"lecture_code=(timeinfo!=null?timeinfo:0)\" ng-model=lecture_code ng-disabled=\"class_info.time_set==0?false:true\"><md-option ng-repeat=\"item in timemodel\" ng-value=item.lecture_code><div ng-repeat=\"time in item.timemodel_times\">{{day_str[time.day]}} : {{time.start_time.slice(0,5)}}-{{time.finish_time.slice(0,5)}}</div></md-option></md-select></md-input-container><md-input-container class=md-block style=margin-bottom:0px flex><label>플립 러닝</label><md-select ng-init=\"isflipped=info.isflipped\" ng-model=isflipped ng-disabled=\"class_info.isflipped!=0\"><md-option ng-repeat=\"item in isflipped_str\" ng-value=item.isflipped>{{item.text}}</md-option></md-select></md-input-container><md-input-container class=md-block style=margin-bottom:0px flex><label>국제어 여부</label><md-select ng-init=\"foreign_select=info.foreign_select\" ng-model=foreign_select ng-disabled=\"class_info.foreign_select!=0\"><md-option ng-repeat=\"item in foreign_select_str\" ng-value=item.foreign_select>{{item.text}}</md-option></md-select></md-input-container><!--\r\n                <md-input-container>\r\n                    <md-checkbox ng-disabled=\"class_info.foreign_select==0?false:true\" ng-init=\"foreign_select=(info.foreign_select==1?true:false)\" class=\"md-primary \" ng-model=\"foreign_select\" required>국제어 강의로 신청(체크하지 않을 시, 비국제어 강의로 신청됩니다.)</md-checkbox>\r\n                </md-input-container>\r\n                --></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=\"req_class(class_info.id,lecture_type,lecture_code,isflipped, foreign_select)\">신청/수정하기</md-button><md-button ng-click=hide()>취소</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/classreq/dialog_reqinfo.html","<md-dialog><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>{{class_info.subjects_id}}-{{class_info.classno}} 강의 신청 정보</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content ng-show=\"reqinfo.length <= 0\" class=content_noreq><p class=text_warning layout-padding><br>해당 강의의 신청 정보가 존재하지 않습니다.</p></md-dialog-content><md-dialog-content ng-show=\"reqinfo.length > 0\"><md-table-container><table md-table class=table_reqinfo><thead md-head md-order=query.order><tr md-row><th md-column md-order-by=professor.uid><span class=title_size>내선번호</span></th><th md-column md-order-by=professor.name><span class=title_size>교수명</span></th><th md-column md-numeric md-order-by=professor.email><span class=title_size>이메일</span></th><th md-column md-numeric md-order-by=professor.dept_key><span class=title_size>소속</span></th><th md-column md-order-by=lecture_type><span class=title_size>수업형태</span></th><th md-column md-order-by=lecture_code><span class=title_size>수업모형</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"info in reqinfo | filter: filter.search | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\"><td md-cell>{{info.professor.uid}}</td><td md-cell>{{info.professor.name}}</td><td md-cell>{{info.professor.email}}</td><td md-cell>{{info.professor.dept.deptname}}</td><td md-cell>{{lecture_type_str[info.lecture_type]}} {{foreign_select_str[info.foreign_select]}}</td><!--{{isflipped_str[info.isflipped]}}--><td md-cell>{{info.lecture_code}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=query.limit md-page=query.page md-total={{reqinfo.length}} md-page-select md-boundary-links></md-table-pagination></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=hide()>닫기</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/fixedClassList/fixedClassList.html","<md-card ng-controller=\"fixedClassListController as fixedcon\" ng-cloak><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_fixed><thead md-head md-order=fixedcon.query.order><tr md-row><th md-column md-numeric md-numeric md-order-by=semester style=\"color: red\"><span class=title_size>학기↕</span></th><th md-column md-order-by=subjects_id><span class=title_size>학수번호↕</span></th><th md-column md-order-by=subject.name><span class=title_size>과목명↕</span></th><th md-column md-numeric md-order-by=classno><span class=title_size>분반↕</span></th><th md-column md-numeric md-order-by=subject.credit><span class=title_size>학점↕</span></th><th md-column md-numeric md-order-by=subject.timeunit><span class=title_size>시수↕</span></th><th md-column md-order-by=subject.graduate><span class=title_size>학부↕</span></th><th md-column md-order-by=lecture_type><span class=title_size>수업형태↕</span></th><th md-column md-order-by=timemodel.lecture_code><span class=title_size>수업코드↕</span></th><th md-column><span class=title_size>비고</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"fixedlist in fixedcon.fixedList | filter: filter.search | orderBy: fixedcon.query.order | limitTo: fixedcon.query.limit : (fixedcon.query.page -1) * fixedcon.query.limit\"><td md-cell ng-if=\"fixedlist.semester==1\">{{fixedlist.semester}}</td><td md-cell ng-if=\"fixedlist.semester==2\" style=\"color: red\">{{fixedlist.semester}}</td><td md-cell>{{fixedlist.subjects_id}}</td><td md-cell class=breakall>{{fixedlist.subject.name}}</td><td md-cell>{{fixedlist.classno}}</td><td md-cell>{{fixedlist.subject.credit}}</td><td md-cell class=breakall>{{fixedlist.subject.timeunit}}</td><td md-cell class=breakall>{{fixedlist.subject.graduate==1?\"학부\":\"대학원\"}}</td><td md-cell class=breakall ng-if=\"fixedlist.lecture_type!=5\">{{fixedcon.lecture_type_str[fixedlist.lecture_type]}} {{fixedcon.stype_str[fixedlist.subject.stype]}} {{fixedcon.foreign_select_str[fixedlist.foreign_select]}} {{fixedcon.isflipped_str[fixedlist.isflipped]}}</td><td md-cell class=breakall ng-if=\"fixedlist.lecture_type==5\">{{fixedcon.stype_str[fixedlist.subject.stype]}} {{fixedcon.foreign_select_str[fixedlist.foreign_select]}} {{fixedcon.isflipped_str[fixedlist.isflipped]}}</td><td md-cell class=breakall>{{fixedlist.timemodel.lecture_code}}</td><td md-cell class=breakall>{{fixedlist.memo}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=fixedcon.query.limit md-page=fixedcon.query.page md-total={{fixedcon.fixedList.length}} md-page-select md-boundary-links></md-table-pagination></md-card>");
$templateCache.put("app/layout/footer.html","<div layout=row layout-align=\"center center\"><div class=footer-text><span class=md-caption>성균관대학교 자연과학캠퍼스 정보통신/소프트웨어대학<br><!--<a href=\"#\" onclick=\"window.open(\'http://scg.skku.ac.kr\'); return false\"--> <a target=_blank href=http://scg.skku.ac.kr class=tooltip data-toggle=tooltip data-placement=top style=\"color: black\"><md-tooltip md-direction=top>#15최원영 #20조기윤 #20최서연 #21김대진 #21김종헌 #21박은찬 #21안정혁 #21한상미</md-tooltip>© Copyright 2017 시스템컨설턴트그룹 All Rights Reserved.</a></span></div></div>");
$templateCache.put("app/layout/header.html","<md-toolbar><div class=md-toolbar-tools><div ng-controller=\"LayoutController as layout\"><ng-md-icon icon=menu ng-click=layout.toggleLeft() hide-gt-md style=margin-right:10px;cursor:pointer></ng-md-icon><h2 style=\"font-size: 23pt\">{{layout.stateParams.title}}</h2></div><span flex></span><md-button ng-controller=\"LoginController as login\" class=md-raised ng-click=login.logout();><a href=\"\"></a>로그아웃</md-button></div></md-toolbar>");
$templateCache.put("app/layout/login.html","<html><head><meta charset=UTF-8><title>로그인 페이지</title></head><body><hgroup></hgroup><form class=form_login ng-controller=\"LoginController as login\"><div class=group><input class=input_login type=text ng-model=login.uid><span class=highlight></span><span class=bar></span><labal class=label_login>아이디</labal></div><div class=group><input class=input_login type=password id=password_input ng-model=login.pw><span class=highlight></span><span class=bar></span><label class=label_login>비밀번호</label></div><button type=button class=\"button_login buttonBlue\" ng-click=login.login()>로그인<div class=\"ripples buttonRipples\"><span class=ripplesCircle></span></div></button></form></body></html>");
$templateCache.put("app/layout/sidebar.html","<md-toolbar class=\"md-tall md-hue-2\"><span flex></span><div layout=column class=\"md-toolbar-tools-bottom inset\"><span></span><div align=center><img style=\"width: 240px\" ; src=/assets/images/logo_main.png></div></div></md-toolbar><md-list><!--\n    사이드바 닫는 버튼 따로 필요 없다고 생각됨\n    <md-button ng-click=\"layout.close()\" class=\"md-accent\" hide-gt-md=\"\">\n        Close Sidebar\n    </md-button>\n    --><!-- {{layout.stateParams.user}} --><div ng-switch on=layout.user><md ng-switch-when=prof><div class=md-div-name><br>{{layout.prof_info.name}} 교수님<p class=md-div-num>(내선번호 {{layout.prof_info.uid}})</p><br><md-divider></md-divider><form ng-submit=layout.modifyAssigned()><table class=table_credit><tr><th>구분</th><th>전체</th><th>학부</th><th>국제어</th></tr><tr><td style=color:dodgerblue>신청</td><td>{{layout.prof_info.total_requested}}</td><td>{{layout.prof_info.undergrad_requested}}</td><td>{{layout.prof_info.foreign_requested}}</td></tr><tr><td style=color:deeppink>확정</td><td>{{layout.prof_info.total_determined}}</td><td>{{layout.prof_info.undergrad_determined}}</td><td>{{layout.prof_info.foreign_determined}}</td></tr><td></td></table></form><br></div><!-- 학점표 끝 --><md-divider></md-divider><md-subheader>메뉴</md-subheader><md-divider></md-divider><md-list-item ui-sref={{item.link}} ng-repeat=\"item in layout.prof\" ui-sref-opts=\"{reload: true}\"><ng-md-icon icon={{item.icon}} style=\"margin-top:0; margin-bottom:10px\"></ng-md-icon><p style=size:0.9em>{{ item.title }}</p></md-list-item></md><md ng-switch-when=admin><md-subheader>메뉴</md-subheader><md-divider></md-divider><md-list-item ui-sref={{item.link}} ng-repeat=\"item in layout.admin\" ui-sref-opts=\"{reload: true}\"><ng-md-icon icon={{item.icon}} style=\"margin-top:0; margin-bottom:10px\"></ng-md-icon><p style=size:0.9em>{{ item.title }}</p></md-list-item></md><md-item ng-switch-default><a>Error<!-- user값 파라미터로 넘어오지 않음 --></a></md-item></div></md-list>");
$templateCache.put("app/requestprof/divideClass.html","<md-dialog class=dialog_class><md-toolbar><div class=md-toolbar-tools><h2>분반 추가</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=text_warning ng-show=\"str_error != null\">{{str_error}}<br><br></div><form name=divideClassform><md-input-container flex><label>분반 번호</label><input required ng-init=\"class_number = request.classes_lecture.classno\" ng-model=class_number name=input_classno type=number ng-min=1 step=1><div ng-messages><div ng-message=required ng-show=\"divideClassform.input_classno.$error[\'required\']\">분반 번호를 입력해주십시오.</div><div ng-message=number ng-show=\"divideClassform.input_classno.$error[\'number\']\">숫자만 입력해주세요.</div><div ng-message=min ng-show=\"divideClassform.input_classno.$error[\'min\']\">1이상의 정수를 입력해주세요.</div><div ng-message=step ng-show=\"divideClassform.input_classno.$error[\'step\']\">정수를 입력해주세요.</div></div></md-input-container><br><md-input-container flex><label>학기</label><md-select ng-init=\"class_semester = request.classes_lecture.semester\" ng-model=class_semester required><md-option ng-repeat=\"item in semester_list\" ng-value=item.semester>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>국제어강의여부</label><md-select ng-init=\"class_foreign = request.classes_lecture.foreign_select\" ng-model=class_foreign required><md-option ng-repeat=\"item in foreign_list\" ng-value=item.foreign>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>flipped강의여부</label><md-select ng-init=\"class_flipped = request.classes_lecture.isflipped\" ng-model=class_flipped required><md-option ng-repeat=\"item in flipped_list\" ng-value=item.flipped>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>6-Module</label><md-select ng-init=\"class_type = request.classes_lecture.lecture_type\" ng-model=class_type required><md-option ng-repeat=\"item in type_list\" ng-value=item.type>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex><label>시간자유선택</label><md-select ng-init=\"class_time = (request.classes_lecture.timemodel?0:1)\" ng-model=class_time required><md-option ng-repeat=\"item in time_list\" ng-value=item.time>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container flex ng-show=!class_time><label>수업코드(수업모형)</label><md-select ng-init=\"class_timemodel = request.classes_lecture.timemodel.id\" ng-model=class_timemodel required><md-option ng-repeat=\"item in timemodel_list\" ng-value=item.id>{{item.lecture_code}}</md-option></md-select></md-input-container><br><md-input-container flex><label>비고</label><textarea ng-model=class_memo></textarea></md-input-container><br></form></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=\"divideClass(class_number, class_semester, class_type, class_time, class_timemodel, class_foreign, class_flipped, class_memo)\">분리하기</md-button><md-button ng-click=hide()>취소</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/requestprof/request.html","<md-card ng-controller=\"RequestController as reqcon\" ng-cloak><md-button class=\"md-primary md-raised\" ng-click=reqcon.print(); ng-href={{reqcon.wantedValue}} target=_self>통계 출력</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:90% ng-model=filter.search type=text placeholder=검색></md-input-container></md-card><md-table-container><table md-table class=table_req><thead md-head md-order=reqcon.query.order><tr md-row><th md-column md-numeric md-order-by=classes_lecture.semester><span class=title_size style=\"color: red\">학기</span></th><th md-column md-numeric md-order-by=classes_lecture.subjects_id><span class=title_size>학수번호</span></th><th md-column md-numeric md-order-by=classes_lecture.subject.name><span class=title_size>과목명</span></th><th md-column md-numeric md-order-by=classes_lecture.classno><span class=title_size>분반</span></th><th md-column md-order-by=professor_id><span class=title_size>내선번호</span></th><th md-column md-order-by=professor.name><span class=title_size>교수명</span></th><th md-column md-order-by=professor.email><span class=title_size>이메일</span></th><th md-column md-order-by=professor.dept_key><span class=title_size>소속</span></th><th md-column md-order-by=classes_lecture.foreign_select><span class=title_size>수업형태</span></th><th md-column md-order-by=lecture_code><span class=title_size>수업모형</span></th><th md-column md-order-by=createdAt><span class=title_size>신청시간</span></th><th md-column md-order-by=\"\"><span class=title_size>관리</span></th></tr></thead><tbody md-bodylayout=row><tr md-row ng-repeat=\"request in reqcon.request_info | filter: filter.search | orderBy: reqcon.query.order | limitTo: reqcon.query.limit : (reqcon.query.page -1) * reqcon.query.limit\"><td md-cell ng-if=\"request.classes_lecture.semester==1\">{{request.classes_lecture.semester}}</td><td md-cell ng-if=\"request.classes_lecture.semester==2\" style=\"color: red\">{{request.classes_lecture.semester}}</td><td md-cell class=breakall>{{request.classes_lecture.subjects_id}}</td><td md-cell>{{request.classes_lecture.subject.name}}</td><td md-cell>{{request.classes_lecture.classno}}</td><td md-cell class=breakall>{{request.professor_id}}</td><td md-cell class=breakall>{{request.professor.name}}</td><td md-cell class=breakall>{{request.professor.email}}</td><td md-cell class=breakall>{{reqcon.dept_key_str[request.professor.dept_key]}}</td><td md-cell ng-if=\"request.lecture_type!=5\">{{reqcon.lecture_type_str[request.lecture_type]}} {{reqcon.foreign_select_str[request.foreign_select]}} {{reqcon.isflipped_str[request.isflipped]}}</td><td md-cell ng-if=\"request.lecture_type==5\">{{reqcon.foreign_select_str[request.foreign_select]}} {{reqcon.isflipped_str[request.isflipped]}}</td><td md-cell class=breakall>{{request.lecture_code}}</td><td md-cell>{{request.createdAt}}</td><td md-cell><md-button class=md-primary ng-click=reqcon.showlectureFix(request);>교수 확정</md-button><md-button class=md-accent ng-click=reqcon.showacceptOffer(request);>분반 분리</md-button></td></tr></tbody></table></md-table-container><div class=mes>{{reqcon.message}}</div><md-table-pagination md-limit=reqcon.query.limit md-page=reqcon.query.page md-total={{reqcon.request_info.length}} md-page-select md-boundary-links></md-table-pagination></md-card>");
$templateCache.put("app/system/system.html","<md-card ng-controller=\"SystemController as app\" style=\"padding-left: 8px\"><md-card-title><md-card-title-text><span class=md-headline style=margin-top:7px>연도 설정</span></md-card-title-text></md-card-title><md-input-container style=\"margin-top:20px; margin-bottom:0px; width: 20%\" flex><label>현재년도</label><input ng-model=app.year></md-input-container><md-button ng-click=app.setYear(app.year)>설정</md-button></md-card>");
$templateCache.put("app/timemodel/dialog_add.html","<md-dialog style=width:300px><md-toolbar><div class=md-toolbar-tools><h2>새로운 수업 모형 추가</h2><span flex></span><md-button class=md-icon-button ng-click=hide()><ng-md-icon icon=close></ng-md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content>새로운 수업 모형을 추가합니다.<br><div class=text_warning ng-show=\"str_error != null\">{{str_error}}</div><br><form name=form_add_timemodel><md-input-container class=input_timemodel><label>수업 모형 이름</label><input required ng-model=model_code name=input_code><div ng-messages><div ng-message=required ng-show=\"form_add_timemodel.input_code.$error[\'required\']\">모형 이름을 입력해주세요. (ex:AC1030)</div></div></md-input-container><md-input-container class=input_timemodel><label>시수</label><input required ng-model=model_timeunit type=number ng-pattern=/^[0-9]*$/ name=input_timeunit><div ng-messages><div ng-message=required ng-show=\"form_add_timemodel.input_timeunit.$error[\'required\']\">수업 시수를 입력해주세요. (ex:3)</div><div ng-message=number ng-show=\"form_add_timemodel.input_timeunit.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container><md-input-container class=input_timemodel style=\"margin-top:20px; margin-bottom:0px\" flex><label>학부/대학원</label><md-select ng-model=model_graduate required><md-option ng-repeat=\"item in graduate_list\" ng-value=item.graduate>{{item.text}}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=add_model(model_code,model_timeunit,model_graduate)>추가하기</md-button><md-button ng-click=hide()>취소</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/timemodel/timemodelList.html","<div ng-controller=\"timeModelController as timemodel\" ng-init=timemodel.init_timemodel()><br><md-button class=\"md-raised md-primary\" ng-click=timemodel.show_add_model();>새로운 모형 추가</md-button><md-card><md-input-container md-no-float class=md-block><ng-md-icon icon=search style=margin-left:5px></ng-md-icon><input style=max-width:80% ng-model=search_model type=text placeholder=검색></md-input-container></md-card><br><md-card class=head_card><p class=head_card_text>공통 항목 (대학원, 학부)</p></md-card><md-card md-theme=\"\'default\'\" md-theme-watch ng-repeat=\"model in timemodel.list_timemodel | filter:search_model\" ng-show=\"model.graduate==2\"><md-card-title><md-card-title-text><span class=md-headline style=margin-top:7px>{{model.lecture_code}} (시수 : {{model.timeunit}})</span></md-card-title-text><md-button ng-click=\"time_plus=!time_plus\">시간 추가</md-button><md-button ng-click=\"model_modify=!model_modify\" class=md-primary>모형 수정</md-button><md-button class=md-accent ng-click=timemodel.show_delete_model(model)>모형 삭제</md-button></md-card-title><!-- 모형 수정 --><div class=cssSlideUp ng-init=\"model_modify=false\" ng-show=model_modify><md-divider></md-divider><md-list-item><div layout-gt-sm=row><form name=form_mod_model><md-input-container style=\"margin-top:40px; margin-bottom:10px; min-width:100px\"><label>유형</label><md-select ng-init=\"mod_graduate =model.graduate\" ng-model=mod_graduate required><md-option ng-repeat=\"item in timemodel.graduate_list\" ng-value=item.graduate>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>수업 모형 이름</label><input ng-init=\"mod_code =model.lecture_code\" ng-model=mod_code name=input_mod_code required><div ng-messages><div ng-message=required ng-show=\"form_mod_model.input_mod_code.$error[\'required\']\">모형 이름를 입력해주세요. (ex:AC1030)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시수</label><input ng-init=\"mod_timeunit =model.timeunit\" ng-model=mod_timeunit type=number name=input_mod_timeunit required ng-pattern=/^[0-9]*$/ ><div ng-messages><div ng-message=required ng-show=\"form_mod_model.input_mod_timeunit.$error[\'required\']\">시수를 입력해주세요. (ex:3)</div><div ng-message=number ng-show=\"form_mod_model.input_mod_timeunit.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.modify_model(model.id,mod_code,mod_timeunit,mod_graduate);model_modify=!model_modify\">수정하기</md-button></md-list-item></md-list-item></div><!-- 모형 수정 끝 --><md-divider></md-divider><!-- 시간 목록 --><div ng-show=\"model.timemodel_times.length==0\"><md-list-item><p class=text_warning><br>모형에 해당하는 시간이 존재하지 않습니다.<br>시간 추가를 통해 시간을 추가해주세요.<br><br></p></md-list-item></div><div ng-hide=\"model.timemodel_times.length==0\" ng-repeat=\"time in model.timemodel_times\"><md-list-item><p>{{timemodel.day_str[time.day]}} : {{time.start_time}} - {{time.finish_time}}</p><md-menu class=md-secondary><md-button class=md-icon-button><ng-md-icon icon=menu></ng-md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"time_modify[$index]=!time_modify[$index]\">시간 수정</md-button></md-menu-item><md-menu-item><md-button ng-click=timemodel.show_delete_time(time)>시간 삭제</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><!-- 시간 수정 --><div class=cssSlideUp ng-init=\"time_modify[$index]=false\" ng-show=time_modify[$index]><md-list-item><div layout-gt-sm=row><form name=form_mod_time><md-input-container style=\"margin-top:40px; margin-bottom:0px\"><label>요일</label><md-select ng-init=\"mod_time_day = time.day\" ng-model=mod_time_day required><md-option ng-repeat=\"day in timemodel.day_list\" ng-value=day.day>{{day.text}}요일</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시작 시간</label><input name=input_mod_time_start ng-init=\"mod_time_start = time.start_time\" ng-model=mod_time_start required><div ng-messages><div ng-message=required ng-show=\"form_mod_time.input_mod_time_start.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>종료 시간</label><input name=input_mod_time_finish ng-init=\"mod_time_finish = time.finish_time\" ng-model=mod_time_finish required><div ng-messages><div ng-message=required ng-show=\"form_mod_time.input_mod_time_finish.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.modify_time(time.id,mod_time_day,mod_time_start,mod_time_finish);time_modify[$index]=!time_modify[$index]\">수정하기</md-button></md-list-item></md-list-item><md-divider></md-divider></div></div><!-- 시간 수정 끝 --><!-- 시간 목록 끝 --><!-- 시간 추가 --><div class=cssSlideUp ng-init=\"time_plus=false\" ng-show=time_plus><md-divider></md-divider><md-list-item><div layout-gt-sm=row><form name=form_add_time><md-input-container style=\"margin-top:40px; margin-bottom:0px\"><label>요일</label><md-select ng-model=add_day required><md-option ng-repeat=\"day in timemodel.day_list\" ng-value=day.day>{{day.text}}요일</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시작 시간</label><input name=input_add_start ng-model=add_start required><div ng-messages><div ng-message=required ng-show=\"form_add_time.input_add_start.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>종료 시간</label><input name=input_add_finish ng-model=add_finish required><div ng-messages><div ng-message=required ng-show=\"form_add_time.input_add_finish.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.add_time(model.id,add_day,add_start,add_finish);time_plus=!time_plus;\">추가하기</md-button></md-list-item></md-list-item></div><!-- 시간 추가 끝 --></md-card><!-------------------------------------------------------------------------- 학부 ------------------------------------------------------------><br><md-card class=head_card><p class=head_card_text>학부</p></md-card><md-card md-theme=\"\'default\'\" md-theme-watch ng-repeat=\"model in timemodel.list_timemodel | filter:search_model\" ng-show=\"model.graduate==1\"><md-card-title><md-card-title-text><span class=md-headline style=margin-top:7px>{{model.lecture_code}} (시수 : {{model.timeunit}})</span></md-card-title-text><md-button ng-click=\"time_plus=!time_plus\">시간 추가</md-button><md-button ng-click=\"model_modify=!model_modify\" class=md-primary>모형 수정</md-button><md-button class=md-accent ng-click=timemodel.show_delete_model(model)>모형 삭제</md-button></md-card-title><!-- 모형 수정 --><div class=cssSlideUp ng-init=\"model_modify=false\" ng-show=model_modify><md-divider></md-divider><md-list-item><div layout-gt-sm=row><form name=form_mod_model><md-input-container style=\"margin-top:40px; margin-bottom:10px; min-width:100px\"><label>유형</label><md-select ng-init=\"mod_graduate =model.graduate\" ng-model=mod_graduate required><md-option ng-repeat=\"item in timemodel.graduate_list\" ng-value=item.graduate>{{item.text}}</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>수업 모형 이름</label><input ng-init=\"mod_code =model.lecture_code\" ng-model=mod_code name=input_mod_code required><div ng-messages><div ng-message=required ng-show=\"form_mod_model.input_mod_code.$error[\'required\']\">모형 이름를 입력해주세요. (ex:AC1030)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시수</label><input ng-init=\"mod_timeunit =model.timeunit\" ng-model=mod_timeunit type=number name=input_mod_timeunit required ng-pattern=/^[0-9]*$/ ><div ng-messages><div ng-message=required ng-show=\"form_mod_model.input_mod_timeunit.$error[\'required\']\">시수를 입력해주세요. (ex:3)</div><div ng-message=number ng-show=\"form_mod_model.input_mod_timeunit.$error[\'number\']\">숫자만 입력해주세요.</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.modify_model(model.id,mod_code,mod_timeunit,mod_graduate);model_modify=!model_modify\">수정하기</md-button></md-list-item></md-list-item></div><!-- 모형 수정 끝 --><md-divider></md-divider><!-- 시간 목록 --><div ng-show=\"model.timemodel_times.length==0\"><md-list-item><p class=text_warning><br>모형에 해당하는 시간이 존재하지 않습니다.<br>시간 추가를 통해 시간을 추가해주세요.<br><br></p></md-list-item></div><div ng-hide=\"model.timemodel_times.length==0\" ng-repeat=\"time in model.timemodel_times\"><md-list-item><p>{{timemodel.day_str[time.day]}} : {{time.start_time}} - {{time.finish_time}}</p><md-menu class=md-secondary><md-button class=md-icon-button><ng-md-icon icon=menu></ng-md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"time_modify[$index]=!time_modify[$index]\">시간 수정</md-button></md-menu-item><md-menu-item><md-button ng-click=timemodel.show_delete_time(time)>시간 삭제</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><!-- 시간 수정 --><div class=cssSlideUp ng-init=\"time_modify[$index]=false\" ng-show=time_modify[$index]><md-list-item><div layout-gt-sm=row><form name=form_mod_time><md-input-container style=\"margin-top:40px; margin-bottom:0px\"><label>요일</label><md-select ng-init=\"mod_time_day = time.day\" ng-model=mod_time_day required><md-option ng-repeat=\"day in timemodel.day_list\" ng-value=day.day>{{day.text}}요일</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시작 시간</label><input name=input_mod_time_start ng-init=\"mod_time_start = time.start_time\" ng-model=mod_time_start required><div ng-messages><div ng-message=required ng-show=\"form_mod_time.input_mod_time_start.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>종료 시간</label><input name=input_mod_time_finish ng-init=\"mod_time_finish = time.finish_time\" ng-model=mod_time_finish required><div ng-messages><div ng-message=required ng-show=\"form_mod_time.input_mod_time_finish.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.modify_time(time.id,mod_time_day,mod_time_start,mod_time_finish);time_modify[$index]=!time_modify[$index]\">수정하기</md-button></md-list-item></md-list-item><md-divider></md-divider></div></div><!-- 시간 수정 끝 --><!-- 시간 목록 끝 --><!-- 시간 추가 --><div class=cssSlideUp ng-init=\"time_plus=false\" ng-show=time_plus><md-divider></md-divider><md-list-item><div layout-gt-sm=row><form name=form_add_time><md-input-container style=\"margin-top:40px; margin-bottom:0px\"><label>요일</label><md-select ng-model=add_day required><md-option ng-repeat=\"day in timemodel.day_list\" ng-value=day.day>{{day.text}}요일</md-option></md-select></md-input-container><br><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>시작 시간</label><input name=input_add_start ng-model=add_start required><div ng-messages><div ng-message=required ng-show=\"form_add_time.input_add_start.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container><md-input-container style=\"margin-top:20px; margin-bottom:0px\"><label>종료 시간</label><input name=input_add_finish ng-model=add_finish required><div ng-messages><div ng-message=required ng-show=\"form_add_time.input_add_finish.$error[\'required\']\">시간을 입력해주세요. (ex:15:00:00)</div></div></md-input-container></form></div><md-list-item class=secondary-button-padding><md-button class=md-secondary ng-click=\"timemodel.add_time(model.id,add_day,add_start,add_finish);time_plus=!time_plus;\">추가하기</md-button></md-list-item></md-list-item></div><!-- 시간 추가 끝 --></md-card><br></div>");}]);